import React, { useEffect, useRef, useState, useCallback } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { IoIosArrowForward } from "react-icons/io";
import { IoMdHome } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { FaHourglassHalf } from "react-icons/fa";
import { RiShareFill } from "react-icons/ri";
import { BiMessageDetail } from "react-icons/bi";
import { PiPhoneCallFill } from "react-icons/pi";
import { SlArrowDown } from "react-icons/sl";
import { SlArrowUp } from "react-icons/sl";
import { MdWork } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import axiosInstance, { Razorpay_Key } from "../../Services/axios";
import "../../Assets/Images/STAR_OUTLINE.png";
import defaultperson from "../../Assets/Images/defaultperson.jpg";
import { IoIosStarOutline } from "react-icons/io";
import { IoMdStar } from "react-icons/io";
import { useUser } from "../../Components/UserContext";
import { getDatabase, ref, onValue } from "firebase/database";
import VerticalStepper from "../../Components/stepper";
import "bootstrap/dist/css/bootstrap.min.css";
import { Offcanvas } from "bootstrap";
import Loading from "react-loading";
import AppointmentCancelled from "../../Assets/Images/Appointment.jpg";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import SuccessLotie from "../../Assets/lottieFiles/success.json";
import useRazorpay from "react-razorpay";
import { IoMdCloseCircle } from "react-icons/io";
import tick_icon from "../../Assets/Images/icons/tick_icon.png"
import live_tracking_lens from "../../Assets/Images/icons/live_tracking_lens.png"
import apply_coupon from "../../Assets/Images/icons/apply_coupon.png"

import { IoMdClose } from "react-icons/io";
import bell_icon from "../../Assets/Images/icons/bell_icon.png"
import door_icon from "../../Assets/Images/icons/door_icon.png"
import Avoid_call from "../../Assets/Images/icons/avoid_call_icon.png"
import gurard_icon from "../../Assets/Images/icons/guard_icon.png"
import pet_foot from "../../Assets/Images/icons/pet_foot_icon.png"
import { IoSend } from "react-icons/io5";
import { RiErrorWarningLine } from "react-icons/ri";
import select_circle from "../../Assets/Images/icons/select_rectangle.png"
import unselect_circle from "../../Assets/Images/icons/unselect_rectangle.png"
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaSquareCheck } from "react-icons/fa6";
import success_audio from "../../Assets/Audios/success.mp3"
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import { FaPlay } from "react-icons/fa";
import { FaPause, FaStop, FaMicrophone } from "react-icons/fa6";
import { MdDeleteOutline } from "react-icons/md";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import Skeleton from "react-loading-skeleton";
import { MdEditDocument } from "react-icons/md";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import { useSelector } from "react-redux";
import { FaRegSquarePlus, FaCircleCheck } from "react-icons/fa6";
import ChangeDeliverytypeOffcanvas from "../../Components/offCanvas/changeDeliverytypeOffcanvas";
import DownLossdbillingPDF from "../../Components/downloadBillingPDF";
import {
  fetchUserOrderDetails, fetchUserOrderRefundDetails, productConfirmCancelOrder, productConfirmReassignOrder,
  submitPilotOrderRating, submitProductOrderRating, UpdateDeliveryInstructions, userAcceptEditOrderRequest,
  userCancelCourierChargeRequest, userCancelEditOrderRequest, userOrderRaiseDispute, userRejectBalancePaymentRequest
} from "../../Services/api";
import NodeaxiosInstance from "../../Services/nodeaxios";


const ProductPass = () => {

  const valueParam = useParams();
  const order_id = valueParam.product_order_id ? valueParam.product_order_id : valueParam.order_id;
  const timerRef = useRef(null);

  const [Razorpay] = useRazorpay();
  const currentUser = useUser(); // Access user context
  const locations = useLocation();
  const { orderid, flowtype, fromPage } = locations.state || {};


  const navigate = useNavigate();
  const paymentSuccessModalRef = useRef(null);
  const canceldisputeModalRef = useRef(null);
  const cancelRefundModalRef = useRef(null);
  const cancelConfirmModalRef = useRef(null);
  const editOrderModalRef = useRef(null);
  const instructionsNoteRef = useRef(null);
  const cancelOrderConfirmModalRef = useRef(null);
  const deliverypersonunavailableRef = useRef(null);
  const offcanvasRef = useRef(null);
  const cancelBalanceRequestModalRef = useRef(null);
  const payBalancerequestModal = useRef(null);
  const courierpaymentRequestRef = useRef(null);
  const cancelcourierpaymentRequestRef = useRef(null);


  const [showContent, setshowContent] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showStaffDetails, setShowStaffDetails] = useState(false);
  const [product, setProduct] = useState('');
  const [location, setLocation] = useState();
  const [staff, setStaff] = useState([]);
  const [user, setUser] = useState([]);
  const [vendor, setVendor] = useState('');
  const [orderdetail, setOrderdetail] = useState(['']);
  const [gststatus, setGststatus] = useState(false);
  const [payment, setPayment] = useState([]);
  const [deliverystep, setDeliverystep] = useState([]);
  const [cancelorder, setCancelorder] = useState([]);
  const [refund, setRefund] = useState([]);
  const [refundstatus, setRefundstatus] = useState([]);
  const [ratecount, setRatecount] = useState('');
  const [feedback, setFeedback] = useState('');
  const [ratings, setRatings] = useState([false, false, false, false, false]);
  const [pilotstar, setPilotstar] = useState([false, false, false, false, false]);

  const [buyproduct, setBuyproduct] = useState([]);
  const [getproduct, setGetproduct] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [userId, setUserId] = useState();
  const [paymentOrderId, setPaymentOrderId] = useState();
  const [dispute, setDispute] = useState('')
  const [pilotRatecount, setPilotRatecount] = useState('');
  const [delivery_partner_feedback, setDelivery_partner_feedback] = useState('');
  const [pilotratings, setPilotRatings] = useState([false, false, false, false, false]);
  const [showAddonsState, setShowAddonsState] = useState({});
  const [editOrder, setEditOrder] = useState("");

  const [delivery_option, setDelivery_option] = useState(1)
  const [deliverytype, setDeliverytype] = useState();
  const [instructionsOption, setInstructionsOption] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [disputeModalOpen, setDisputeModalOpen] = useState(false)

  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)

  const [isinstructionModalOpen, setIsinstructionModalOpen] = useState(false)

  const [iscourierrequestModalOpen, setIscourierrequestModalOpen] = useState(false)

  const [cancelConfirmModal, setCancelConfirmModal] = useState(false)
  const [consulation, setConsulation] = useState("");
  const [selectedTexts, setSelectedTexts] = useState("")
  const [isChanged, setIsChanged] = useState(false)
  // delivery instructions as last saved on the server
  const savedInstructionsRef = useRef([])
  // note text and voice note as last saved on the server (used to decide when the Send button shows)
  const savedNoteRef = useRef('')
  const savedVoiceRef = useRef('')
  const [ticket_tab, setTicket_tab] = useState(1)
  const [editproductRateing, setEditProductRateing] = useState(false)
  const [editdeliveryRateing, setEditDeliveryRateing] = useState(false)
  const [isLoading, setIsloading] = useState(false)
  const [orderID, setOrderID] = useState()
  const [showUnavailableModal, setShowUnavailableModal] = useState(false);
  const [oldRecordurl, setOldRecordurl] = useState('')
  const [pageLoaded, setPageLoaded] = useState(false)
  const [recordingTime, setRecordingTime] = useState(0);
  const [instructionisLoading, setInstructionIsLoading] = useState(false);

  const [changeDeliveryTypeModal, setChangeDeliveryTypeModal] = useState(false)
  const [changeDeliveryrequestModal, setchangeDeliveryrequestModal] = useState(false)
  const [userLocationListModal, setUserLocationListModal] = useState(false);

  const [userLocation, setUserLocation] = useState([]);


  const paymentAudio = new Audio(success_audio);
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  const [locationBtnloder, setLocationBtnloder] = useState(true);


  useEffect(() => {
    if (!userData?.token) {
      navigate("/login", { state: { fromGuest: true } });
      localStorage.removeItem('login')
      return;
    }
  }, [])

  useEffect(() => {
    if (product?.payment_details?.balence_request?.request_status == 1 && product.payment_details.payment_status == "0") {
      openBalancerequestModal();
      setIsModalOpen(true)
    } else {
      closeBalancerequestModal()
    }
  }, [payment]);


  useEffect(() => {
    if (!currentUser) return;
    const database = getDatabase();
    const orderRef = ref(database, `/orders/${order_id}`);
    const unsubscribe = onValue(orderRef, (snapshot) => {
      const data = snapshot.val();
      getproductDetails();
    });

    return () => unsubscribe();
  }, [currentUser, order_id]);

  useEffect(() => {
    if (!currentUser) return;
    const database = getDatabase();
    const orderRef = ref(database, `/payments/product_order/${userId}`);
    const unsubscribe = onValue(orderRef, (snapshot) => {
      const data = snapshot.val();
      if (data.status == 2 && data.order_id == paymentOrderId) {
        getproductDetails();

        openPaymentSuccessModal();
        setIsModalOpen(true)
      }

    });
    return () => unsubscribe();
  }, [currentUser, paymentOrderId]);

  const [deliveryTypeModal, setDeliveryTypeModal] = useState(false)


  // useEffect(() => {
  //       if (productDetailsRaw?.order_status == 1 && productDetailsRaw?.order_type == "INSTANT") {
  //           database()
  //               .ref(`/instant_delivery/${orderId}`)
  //               .on("value", (snapshot) => {
  //                   console.log(`productDetailsRaw?.order_status `, productDetailsRaw?.order_status);

  //                   const deliveryStatus = snapshot.val();
  //                   if (deliveryStatus !== null) {
  //                       if (deliveryStatus == 3) {
  //                           setDeliveryTypeModal(true);
  //                       } else {
  //                           setDeliveryTypeModal(false);
  //                           if (deliveryStatus == 2) {
  //                               getProductDetails(orderId);
  //                           }
  //                       }
  //                   } else {
  //                       setDeliveryTypeModal(false)
  //                   }
  //               });
  //       } else {
  //           setDeliveryTypeModal(false)
  //       }
  //   }, [orderId, productDetailsRaw]);



  useEffect(() => {

    if (product?.order_status == 1 && product?.order_type == "INSTANT") {
      const database = getDatabase();
      const orderRef = ref(database, `/instant_delivery/${order_id}`);

      onValue(orderRef, (snapshot) => {
        if (snapshot.exists()) {
          getproductDetails();

          if (snapshot.val() == 3) {
            setDeliveryTypeModal(true);
            setShowUnavailableModal(true);
            setTimeout(() => opendeliveryunavailableModal(), 100);
          } else if (snapshot.val() == 2) {
            setDeliveryTypeModal(false);
          }
        }
      });
    }
  }, [order_id, orderID]);

  useEffect(() => {
    getproductDetails();
    localStorage.removeItem("cartID");
  }, []);

  useEffect(() => {
    if (offcanvasRef.current) {
      const bsOffcanvas = new Offcanvas(offcanvasRef.current, {
        backdrop: true,
        scroll: true,
      });


      const triggerButton = document.getElementById("triggerButtonId");
      triggerButton.addEventListener("click", function () {
        bsOffcanvas.toggle();
      });
    }
  }, []);

  const handleStarClick = (index) => {
    const newRatings = [...ratings];
    for (let i = 0; i < newRatings.length; i++) {
      if (i <= index) {
        newRatings[i] = true;
      } else {
        newRatings[i] = false;
      }
    }
    setRatings(newRatings);
    setRatecount(index + 1);
  };

  const handlePiltoStarClick = (index) => {
    const pilotnewRatings = [...pilotstar];
    for (let i = 0; i < pilotnewRatings.length; i++) {
      if (i <= index) {
        pilotnewRatings[i] = true;
      } else {
        pilotnewRatings[i] = false;
      }
    }
    setPilotRatings(pilotnewRatings);
    setPilotRatecount(index + 1);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const toggleStaffDetails = () => {
    setShowStaffDetails(!showStaffDetails);
  };

  const toggleContent = () => {
    setshowContent(!showContent);
  };

  const toggleDeliveryTypeOffCanvas = () => {
    setChangeDeliveryTypeModal(!changeDeliveryTypeModal)
    getproductDetails()
  }

  const isValidAudioUrl = (voiceNote) => typeof voiceNote == "string" && voiceNote.trim() != "";

  const getproductDetails = async () => {
    try {

      let reqData = {
        order_id: order_id,
      };

      let res = await fetchUserOrderDetails(reqData);
      if (res?.status == 200) {
        let data = res.data;

        const voiceNote = data?.order_notes?.voice_note;

        if (isValidAudioUrl(voiceNote)) {
          localStorage.setItem("recordedAudio", voiceNote);

          setOldRecordurl(voiceNote);
          setRecordedAudioUrl(voiceNote);
          setRecordedAudio(voiceNote); // saved note is a URL string, not a new recording Blob
          setRestartRecord(false);

          const audio = new Audio(voiceNote);
          audioRef.current = audio;

          audio.onended = () => setIsPlaying(false);
          audio.onloadedmetadata = () => {
            setRecordingTime(audio.duration);
            localStorage.setItem("audioDuration", audio.duration);
          };

        } else {
          localStorage.removeItem("recordedAudio");
          localStorage.removeItem("audioDuration");
          localStorage.removeItem("recoredURL");
          setOldRecordurl(null);
          setRecordedAudioUrl("");
          setRecordingTime(0);
          setRestartRecord(true);
          setIsPlaying(false);

        }
        if (data?.change_delivery_detail?.request_status == 1) {
          setchangeDeliveryrequestModal(true)
        }

        if (data?.payment_details?.courier_charge_request?.request_status == 1) {
          opencourierpaymentRequestModal()
          setIscourierrequestModalOpen(true)
        } else if (data?.payment_details?.courier_charge_request?.request_status != 1) (
          closecourierpaymentRequestModal()
        )

        setConsulation(data?.order_notes?.additional_notes)
        savedNoteRef.current = data?.order_notes?.additional_notes || '';
        savedVoiceRef.current = isValidAudioUrl(voiceNote) ? voiceNote : '';
        setOrderID(order_id)
        setProduct(data);
        setEditOrder(data?.edit_order_detail)

        setLocation(data?.delevery_address);
        setStaff(data.delivery_staff_detail);
        setUser(data.user_detail);
        setVendor(data.vendor_detail);
        if (data.pre_order_status != 1) {
          setOrderdetail(Array.isArray(data.order_products) ? data.order_products : []);
        }
        // if (data.shipping_type == 2) {
        //   setTicket_tab('2')
        // }


        setGststatus(data.gst_status);
        setPayment(data.payment_details);
        if (Array.isArray(data.delivery_steps_detail)) {
          setDeliverystep(data.delivery_steps_detail);
        }
        setInstructionsOption(data.order_notes.delivery_instructions)
        savedInstructionsRef.current = data.order_notes?.delivery_instructions || [];
        const deliveryInstructions = data.order_notes?.delivery_instructions || [];
        const labelsOnly = deliveryInstructions.filter((item) => typeof item == "string");

        setSelectedTexts(labelsOnly);

        setCancelorder(data.order_cancel_detail);
        setRefundstatus(data.order_cancel_detail);
        setBuyproduct(data.offer_details.buy_products);
        setGetproduct(data.offer_details.get_products);

        if (data?.edit_order_status == "1" && data?.edit_order_detail?.request_status == "1") {
          openEditorderModal()
        }

        if (data?.rating_status == "1") {
          handleStarClick(
            data?.rating_detail?.rate_count ? Number(data?.rating_detail?.rate_count) - 1 : 0
          );
          setFeedback(data?.rating_detail?.rate_description);
        }

        if (data?.pilot_rating_status == true) {

          handlePiltoStarClick(
            data?.pilot_rating_detail?.rate_count ? Number(data?.pilot_rating_detail?.rate_count) - 1 : 0
          )
          setDelivery_partner_feedback(data?.pilot_rating_detail?.pilot_feedback)
        }


      }
    } catch (error) {
      showToast("Try Again Later 1")
    } finally {
      setTimeout(() => {
        setPageLoaded(true)
      }, 2000);
    }
  };



  const formatTime = (sec = 0) => {
    const total = Math.floor(sec);
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
  };




  useEffect(() => {
    if (product?.edit_order_status == "1" && product?.edit_order_detail?.request_status == "1") {
      openEditorderModal()
    }


  }, [product])

  const openCancelmodal = () => {
    cancelRefundModalRef.current.classList.add("show");
    cancelRefundModalRef.current.style.display = "block";
    setIsCancelModalOpen(true)
  }
  const closeCancelmodal = () => {
    cancelRefundModalRef.current.classList.remove('show');
    cancelRefundModalRef.current.style.display = 'none';
    setIsCancelModalOpen(false)
  }

  const getrefund = async () => {
    try {
      let reqdata = {
        order_id: order_id,
      };
      let res = await fetchUserOrderRefundDetails(reqdata);
      if (res?.status == 200) {
        setRefund(res.data.refund_message);
        openCancelmodal()
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const cancel_order = async (type) => {
    try {
      setLoading(true);
      setButtonClicked(true);
      setIsloading(true);

      const reqData = { order_id };

      const res = await productConfirmCancelOrder(reqData);

      if (res.status == 200) {
        setIsloading(false);

        closeCancelmodal()
        if (cancelConfirmModalRef.current) {
          cancelConfirmModalRef.current.classList.add("show");
          cancelConfirmModalRef.current.style.display = "block";
        }

        if (type == 2) {
          closedeliveryunavailableModal();
        }

        if (typeof closecancelOrderModal == "function") {
          closecancelOrderModal();
        }
      }

    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };



  const starRating = async () => {
    try {
      let reqData = {
        order_id: order_id,
        rate_count: ratecount == 0 ? 1 : ratecount,
        rate_description: feedback,
      };
      if (product.rating_status) {
        reqData["rate_id"] = order_id;
      }
      submitProductOrderRating(reqData)
        .then((res) => {
          setEditProductRateing(false)
          getproductDetails()
          showToast("Rating has been submitted.", 'success');
        })
    }
    catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  }


  const delivery_Partner_rateing = async () => {
    try {
      let reqData = {
        order_id: order_id,
        rate_count: pilotRatecount == 0 ? 1 : pilotRatecount,
        pilot_feedback: delivery_partner_feedback,
      };
      if (product.rating_status) {
        reqData["rate_id"] = order_id;
      }
      submitPilotOrderRating(reqData)
        .then((res) => {
          if (res.status == 200) {
            getproductDetails()
            setEditDeliveryRateing(false)

            showToast("Rating has been submitted", "text-success");
          }
        })

    }
    catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  }

  const raisedispute = async () => {
    try {
      let reqData = {
        order_id: order_id,
        reason: dispute
      }

      userOrderRaiseDispute(reqData)
        .then((res) => {
          closeDisputeModal()
          getproductDetails()
        }).catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {

            toast(err.response.data.message, {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              className: "text-danger toast-style-1",
            });
          }
        });
    }
    catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
      }
    }
  }

  const cancelBalanceRequest = async () => {
    try {
      setIsloading(true)
      const reqData = {
        order_id: order_id,
      };

      let res = await userRejectBalancePaymentRequest(reqData);
      if (res?.status == 200) {
        closeCancelBalanceRequestModal()
        setIsloading(false)
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };


  const cancelCorierPaymentRequest = async () => {
    try {
      setIsloading(true)
      const reqData = {
        order_id: order_id,
      };

      const response = await userCancelCourierChargeRequest(reqData);

      if (response.status == 200) {
        const data = response?.data;
        getproductDetails()
        closecancelcourierpaymentRequestModal()
        closecourierpaymentRequestModal()
        setIsloading(false)
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400) {
        }
        console.log("err");
      } else {
        console.log("Non-API error:");
      }
      setIsloading(false);
    }
  };

  const openCencalConfirmModal = () => {
    cancelConfirmModalRef.current.classList.add("show");
    cancelConfirmModalRef.current.style.display = "block";
    // setIsModalOpen(false)
  };

  const closeCencalConfirmModal = () => {
    cancelConfirmModalRef.current.classList.remove("show");
    cancelConfirmModalRef.current.style.display = "none";
    setIsModalOpen(false)
  };

  const payBalance = () => {
    let userDetatil = {
      name: "",
      phone: "",
      email: "",
    };

    if (payment.extra_delivery_charge_status == 1) {
      setPaymentOrderId(payment.courier_charge_request?.payment_order_id);
      setUserId(user?.user_id);
      handlePayment(userDetatil, payment.courier_charge_request.order);
    } else {
      setPaymentOrderId(payment.balence_request?.payment_order_id);
      setUserId(user?.user_id);
      handlePayment(userDetatil, payment.balence_request.order);
    }
  };

  const cancelEditorderRequest = async () => {
    try {
      const reqData = {
        order_id: order_id,
      };

      let res = await userCancelEditOrderRequest(reqData);
      if (res.status == 200) {
        closeEditorderModal()
        getproductDetails()
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const cancelEditdeliveryTypeRequest = async () => {
    setIsloading(true)
    try {
      const reqData = {
        order_id: order_id,
      };

      let res = await userCancelEditOrderRequest(reqData);
      if (res.status == 200) {
        setchangeDeliveryrequestModal(false)
        setIsloading(false)
        getproductDetails()
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const acceptEditorderRequest = async () => {
    try {
      const reqData = { order_id };

      let res = await userAcceptEditOrderRequest(reqData);
      if (res?.status == 200) {

        const allProduct = orderdetail || [];
        const requestedProducts = JSON.parse(editOrder?.requested_products || "[]");

        const EditOrder_Detail = {
          orderid: order_id,
          shippingtype: product?.shipping_type,
          vendorId: vendor?.vendor_id,
          requestedProducts: requestedProducts
        };
        localStorage.setItem('EditOrder_Detail', JSON.stringify(EditOrder_Detail));

        const cart_items = {
          cart_items: orderdetail.map((item) => ({
            product_id: item.product_id,
            quantity: Number(item.added_count) || 0
          })),
          cart_id: order_id,
          cart_count: orderdetail.length,
          sub_total: product?.payment_details?.total_amount,

        };

        localStorage.setItem("cart_items", JSON.stringify(cart_items));

        let productCart = {
          shipping_type: product?.shipping_type,
          cartId: order_id,
          vendorId: vendor?.vendor_id,
        }

        localStorage.setItem('productCart', JSON.stringify(productCart));

        navigate(`/products/${vendor?.vendor_id}`, { state: { flowtype: "EDIT_ORDER" } });
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };


  const handleOkClick = () => {
    setShowModal(false);
    setIsModalOpen(false)
    closeCencalConfirmModal();
    setDeliveryTypeModal(false);
    getproductDetails()
  };

  const copyToClipboard = () => {
    const textToCopy = vendor.vendor_share_link;
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(textarea);
    setCopied(true);

    toast("Link copied!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      className: "text-dark toast-style-1",
    });

    // Reset the copied state after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const handlePayment = useCallback(
    (userData, orderData) => {
      const createOrderAndInitializePayment = async () => {
        const options = {
          key: Razorpay_Key,
          amount: orderData.amount,
          currency: orderData.currency,
          name: "PINGLE",
          description: "Payment",
          image: "https://pingle.in/user/assets/images/LogoUser.png",
          order_id: orderData.id,
          handler: (res) => {


            if (res) {
              openPaymentSuccessModal();
              // onPayment(res); // Passing the order ID to the parent component
            }
          },
          prefill: {
            name: userData.name,
            email: userData.email,
            contact: userData.phone,
          },
          theme: {
            color: "#4E26A3",
          },
        };

        const rzpay = new Razorpay(options);
        rzpay.open();
      };

      createOrderAndInitializePayment();
    },
    [Razorpay]
  );

  const openPaymentSuccessModal = () => {
    setIsChanged(true)
    closecourierpaymentRequestModal()
    paymentSuccessModalRef.current.classList.add("show");
    paymentSuccessModalRef.current.style.display = "block";
  };

  const handleSuccessOkClick = () => {
    setIsChanged(false)
    toggleDeliveryTypeOffCanvas()
    getproductDetails()
    paymentSuccessModalRef.current.classList.remove("show");
    paymentSuccessModalRef.current.style.display = "none";
  };

  const openDisputeModal = () => {
    canceldisputeModalRef.current.classList.add("show");
    canceldisputeModalRef.current.style.display = "block";
    setDisputeModalOpen(true)
  };

  const closeDisputeModal = () => {
    canceldisputeModalRef.current.classList.remove("show");
    canceldisputeModalRef.current.style.display = "none";
    setDisputeModalOpen(false)
  };

  const opencancelOrderModal = () => {
    cancelOrderConfirmModalRef.current.classList.add("show");
    cancelOrderConfirmModalRef.current.style.display = "block";
    setCancelConfirmModal(true)


  };

  const closecancelOrderModal = () => {
    cancelOrderConfirmModalRef.current.classList.remove("show");
    cancelOrderConfirmModalRef.current.style.display = "none";
    setCancelConfirmModal(false)
  };

  const openBalancerequestModal = () => {
    setIsModalOpen(true)
    payBalancerequestModal.current.classList.add("show");
    payBalancerequestModal.current.style.display = "block";
  }


  const closeBalancerequestModal = () => {
    if (payBalancerequestModal.current) {
      payBalancerequestModal.current.classList.remove("show");
      payBalancerequestModal.current.style.display = "none";
      setIsModalOpen(false)
    }
  }


  const opencourierpaymentRequestModal = () => {
    if (courierpaymentRequestRef.current) {
      courierpaymentRequestRef.current.classList.add("show");
      courierpaymentRequestRef.current.style.display = "block";
      setIscourierrequestModalOpen(true);
    }
  };
  const closecourierpaymentRequestModal = () => {
    if (courierpaymentRequestRef.current) {
      courierpaymentRequestRef.current.classList.remove("show");
      courierpaymentRequestRef.current.style.display = "none";
      setIscourierrequestModalOpen(false);
    }
  };

  const opencancelcourierpaymentRequestModal = () => {
    if (cancelcourierpaymentRequestRef.current) {
      cancelcourierpaymentRequestRef.current.classList.add("show");
      cancelcourierpaymentRequestRef.current.style.display = "block";
      setIscourierrequestModalOpen(true);
    }
  };
  const closecancelcourierpaymentRequestModal = () => {

    if (cancelcourierpaymentRequestRef.current) {
      cancelcourierpaymentRequestRef.current.classList.remove('show');
      cancelcourierpaymentRequestRef.current.style.display = 'none';
    }
  }
  const opendeliveryunavailableModal = () => {
    setDeliveryTypeModal(true);
  };


  useEffect(() => {
    if (deliveryTypeModal && deliverypersonunavailableRef.current) {
      deliverypersonunavailableRef.current.classList.add("show");
      deliverypersonunavailableRef.current.style.display = "block";
      setIsModalOpen(true);
    }
  }, [deliveryTypeModal]);



  const closedeliveryunavailableModal = () => {
    if (deliverypersonunavailableRef.current) {
      deliverypersonunavailableRef.current.classList.remove("show");
      deliverypersonunavailableRef.current.style.display = "none";
    }
    setIsModalOpen(false);
    setShowUnavailableModal(false);
  };

  const openEditorderModal = () => {
    editOrderModalRef.current.classList.add("show");
    editOrderModalRef.current.style.display = "block";
    setIsModalOpen(true)

  };

  const closeEditorderModal = () => {
    editOrderModalRef.current.classList.remove("show");
    editOrderModalRef.current.style.display = "none";
    setIsModalOpen(false)
  };




  const toggleAddon = (index) => {
    setShowAddonsState((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const dateOptions = { day: '2-digit', month: 'long', year: 'numeric' };

  const hoursFromNow = (neededHour) => {
    let date = new Date();
    date.setHours(date.getHours() + neededHour);

    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutes} ${ampm}`
  };

  let dateOption = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  };

  // true only when chips, note text or voice note differ from what is saved
  const hasInstructionChanges = () => {
    const sortedJson = (list) => JSON.stringify([...(Array.isArray(list) ? list : [])].sort());
    const chipsChanged = sortedJson(instructionsOption) != sortedJson(savedInstructionsRef.current);
    const noteChanged = (consulation || '').trim() != (savedNoteRef.current || '').trim();
    const voiceChanged = recordedAudio instanceof Blob || (!restartRecord) != !!savedVoiceRef.current;
    return chipsChanged || noteChanged || voiceChanged;
  };

  const handleOptionToggle = (label) => {
    setInstructionsOption((prevOptions) => {
      // 1. compute new state
      const updatedOptions = prevOptions.includes(label)
        ? prevOptions.filter((option) => option !== label)
        : [...prevOptions, label];

      // 2. compare with what is saved on the server
      const storedOptions = savedInstructionsRef.current || [];

      // 3. compare old vs new
      const hasChanged = JSON.stringify([...updatedOptions].sort()) != JSON.stringify([...storedOptions].sort());

      setIsChanged(hasChanged);

      // 4. now update localStorage
      localStorage.setItem(
        "deliveryInstructions",
        JSON.stringify(updatedOptions)
      );

      return updatedOptions;
    });

    setSelectedTexts((prevOptions) =>
      prevOptions.includes(label)
        ? prevOptions.filter((option) => option !== label)
        : [...prevOptions, label]
    );
  };




  const openinstructionsModal = () => {
    instructionsNoteRef.current.classList.add("show");
    instructionsNoteRef.current.style.display = "block";
    setPlayTime(0)
    setIsinstructionModalOpen(true)
  };

  const handleContinue = () => {
    closedeliveryunavailableModal()
    setDeliveryTypeModal(false);
    if (deliverytype == "instant") {
      ReassignOrder()
    } else if (deliverytype == "slot") {
      ChooseSlotDelivery()
    }
  };

  const ReassignOrder = async () => {
    try {
      const data = { order_id: order_id, vendor_id: vendor.vendor_id };
      const res = await productConfirmReassignOrder(data);

      if (res.status == 200) {
        closedeliveryunavailableModal();
        setDeliveryTypeModal(false);
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const ChooseSlotDelivery = async () => {
    try {
      const data = {
        order_id,
        order_delivery_time: "",
        order_delivery_date: "ANY",
      };

      const res = await NodeaxiosInstance.post("/product/order-delivery-time-date-update", data);

      if (res.status == 200) {
        getproductDetails()
      }
    } catch (err) {
      console.error("ChooseSlotDelivery error:", err);
      const status = err.response?.status;

      if (status == 400) {
        toast("Invalid delivery slot. Please try again.", { position: "bottom-center" });
      } else if (status == 500) {
        toast("Server error. Please try again later.", { position: "bottom-center" });
      }
    }
  };




  const handleSendInstructions = async (type) => {
    try {
      if (consulation?.length > 0 && consulation.trim().length === 0) {
        toast.error("Please enter a valid note.");
        return;
      }

      let url = "";

      // a string means the already-saved voice note URL; only a Blob is a new recording to upload
      if (type != 1 && recordedAudio instanceof Blob) {
        setInstructionIsLoading(true)
        const mp4Blob = await convertToMp4(recordedAudio);

        const formData = new FormData();
        formData.append("file", mp4Blob, "audio.mp4");

        const uploadRes = await NodeaxiosInstance.post(
          "/product/upload-audio-note",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (uploadRes.status == 200 && uploadRes.data?.file_url) {
          url = uploadRes.data.file_url;
          localStorage.setItem("recoredURL", url);
        } else {
          console.error("Failed to upload audio note");
          setInstructionIsLoading(false);
          return;
        }
      }

      const reqData = {
        order_id: order_id,
        delivery_instructions: instructionsOption,
        additional_notes: (consulation || "").trim(),
        // a new recording (url) wins; otherwise keep the saved voice note unless the user deleted it (type 1)
        voice_note: type == 1 ? "" : (url || (type == 2 ? (oldRecordurl || "") : (typeof recordedAudio == "string" ? recordedAudio : ""))),
      };

      const updateRes = await UpdateDeliveryInstructions(reqData);

      if (updateRes.status == 200) {

        // saved: hide Send until something changes again
        savedInstructionsRef.current = instructionsOption;
        setIsChanged(false);

        if (type != 1) {
          setInstructionIsLoading(false);
          closeinstructionsModal();
        }
        getproductDetails();
      } else {
        console.error("Failed to update instructions");
        setInstructionIsLoading(false);
        toast.error("Unable to save instructions. Please try again.");
      }
    } catch (error) {
      console.error("Error sending instructions:", error);
      setInstructionIsLoading(false);
      toast.error(error?.response?.data?.message || "Unable to save instructions. Please try again.");
    }
  };


  const [recordedAudio, setRecordedAudio] = useState(null);
  const [pauseicon, setPauseicon] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioDuration, setAudioDuration] = useState(null);
  const [restartRecord, setRestartRecord] = useState(true);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState(null);
  const [oldrecordedAudioblob, setOldRecordedAudioblob] = useState(null);
  const [playTime, setPlayTime] = useState(0);
  const audioRef = useRef(null);

  // Record directly with MediaRecorder: the library's AudioRecorder was unmounted on the same
  // click that started recording, which left the recording empty (header-only webm).
  const mediaRecorderRef = useRef(null);
  const mediaChunksRef = useRef([]);

  const startVoiceRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { noiseSuppression: true, echoCancellation: true }
      });
      const track = stream.getAudioTracks()[0];
      console.log("mic track:", track?.label, "muted:", track?.muted, "state:", track?.readyState);

      mediaChunksRef.current = [];
      const recorder = new MediaRecorder(stream);
      recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) mediaChunksRef.current.push(e.data);
      };
      recorder.onstop = () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(mediaChunksRef.current, { type: recorder.mimeType || "audio/webm" });
        mediaRecorderRef.current = null;
        addAudioElement(blob);
      };
      recorder.start(250); // emit data every 250ms instead of only on stop
      mediaRecorderRef.current = recorder;
      setRecordingTime(0);
      setPauseicon(true);
    } catch (err) {
      console.error("Unable to start recording:", err);
      toast.error("Unable to access the microphone. Please allow microphone access.");
    }
  };

  const stopVoiceRecording = () => {
    const recorder = mediaRecorderRef.current;
    setPauseicon(false);
    if (recorder && recorder.state !== "inactive") recorder.stop();
  };

  const recorderControls = useAudioRecorder(
    {
      noiseSuppression: true,
      echoCancellation: true,
    },
    (err) => console.error(err)
  );


  const closeinstructionsModal = () => {
    instructionsNoteRef.current.classList.remove("show");
    instructionsNoteRef.current.style.display = "none";
    setIsinstructionModalOpen(false)
    setInstructionIsLoading(false)

  };

  // useEffect(() => {
  //   const savedAudio = localStorage.getItem("recordedAudio");

  //   if (savedAudio) {
  //     const audio = new Audio(savedAudio);
  //     audioRef.current = audio;
  //     setOldRecordurl(savedAudio);
  //   }

  //   const storedDuration = localStorage.getItem("audioDuration");


  //   if (savedAudio) {
  //     const newAudio = new Audio(savedAudio);
  //     audioRef.current = newAudio;
  //     newAudio.onended = () => setIsPlaying(false);
  //     setRecordingTime(storedDuration);
  //     setRecordedAudioUrl(savedAudio);
  //     setRestartRecord(false);
  //     setPauseicon(false);
  //     setIsPlaying(false);

  //     newAudio.onloadedmetadata = () => {
  //       setAudioDuration(newAudio.duration.toFixed(2));
  //     };
  //   }
  // }, []);

  // useEffect(() => {
  //   const savedOptions = JSON.parse(localStorage.getItem("deliveryInstructions")) || [];
  //   const additionalNotes = localStorage.getItem("additionalNotes") || "";

  //   setInstructionsOption(savedOptions);
  //   setSelectedTexts(savedOptions);
  //   setConsulation(additionalNotes)
  // }, []);


  useEffect(() => {
    const savedAudio = localStorage.getItem("recordedAudio");
    const storedDuration = localStorage.getItem("audioDuration");

    if (savedAudio) {
      const audio = new Audio(savedAudio);
      audioRef.current = audio;

      audio.onended = () => setIsPlaying(false);

      setOldRecordurl(savedAudio);
      setRecordedAudio(savedAudio);
      setRecordedAudioUrl(savedAudio);
      setRestartRecord(false);
      setPauseicon(false);
      setIsPlaying(false);

      if (storedDuration) {
        setRecordingTime(Number(storedDuration));
      }

      audio.onloadedmetadata = () => {
        setAudioDuration(audio.duration.toFixed(2));
      };
    }
  }, []);


  const addAudioElement = (blob) => {
    if (!blob || (recordedAudio && recordedAudio.size == blob.size)) {

      return;
    }
    console.log("addAudioElement blob:", blob.type, blob.size);
    // a webm with only its header (~100 bytes) means the mic produced no audio
    if (blob.size < 1000) {
      toast.error("No audio was captured. Please check your microphone and record again.");
      setRestartRecord(true);
      setPauseicon(false);
      setRecordingTime(0);
      return;
    }
    if (oldrecordedAudioblob !== blob) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
        audioRef.current.onended = null;
        audioRef.current = null;
      }

      setOldRecordedAudioblob(blob)
      if (recordedAudioUrl) {
        URL.revokeObjectURL(recordedAudioUrl);
      }

      const newAudioUrl = URL.createObjectURL(blob);
      const newAudio = new Audio(newAudioUrl);

      audioRef.current = newAudio;
      audioRef.current.onended = () => {
        setIsPlaying(false);
      };
      setRecordedAudio(blob);
      setRecordedAudioUrl(newAudioUrl);
      setPauseicon(false);
      setRestartRecord(false);
      setIsPlaying(false);

      newAudio.onloadedmetadata = () => {
        // setAudioDuration(newAudio.duration);
        setAudioDuration(Math.ceil(newAudio.duration));
      };


      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;
        const newAudioUrl = URL.createObjectURL(blob);

        localStorage.setItem("recordedAudio", base64data);
      };
      reader.readAsDataURL(blob);
    }
  };

  useEffect(() => {
    const savedOptions =
      JSON.parse(localStorage.getItem("deliveryInstructions")) || [];
    const additionalNotes =
      localStorage.getItem("additionalNotes") || "";

    setInstructionsOption(savedOptions);
    setSelectedTexts(savedOptions);
    setConsulation(additionalNotes);
  }, []);


  const togglePlayAudio = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch(e => console.error("Playback failed:", e));
    }

    setIsPlaying(!isPlaying);
  };



  useEffect(() => {
    let interval;
    if (isPlaying && audioRef.current) {
      interval = setInterval(() => {
        setPlayTime(audioRef.current.currentTime);
      }, 500);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);


  useEffect(() => {
    if (pauseicon) {
      timerRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    return () => clearInterval(timerRef.current);
  }, [pauseicon]);


  const deleteRecordedAudio = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = "";
      audioRef.current = null;
    }
    if (recordedAudioUrl && recordedAudioUrl.startsWith("blob:")) {
      URL.revokeObjectURL(recordedAudioUrl);
    }

    setRecordedAudio(null);
    setRecordedAudioUrl(null);
    setIsPlaying(false);
    setPauseicon(false);

    setOldRecordurl(null);
    setRestartRecord(true);
    setRecordingTime(0);

    // if (recordedAudioUrl == null) {
    handleSendInstructions(1)
    // }

  }, [recordedAudioUrl]);


  const ffmpegRef = useRef(null);

  const convertToMp4 = async (audioBlob) => {
    if (!ffmpegRef.current) ffmpegRef.current = new FFmpeg();
    const ffmpeg = ffmpegRef.current;
    if (!ffmpeg.loaded) await ffmpeg.load();

    const logLines = [];
    const onLog = ({ message }) => logLines.push(message);
    ffmpeg.on("log", onLog);
    console.log("convertToMp4 input blob:", audioBlob.type, audioBlob.size);
    // a webm with only its header (~40 bytes) has no audio in it
    if (audioBlob.size < 1000) {
      throw new Error(`Recorded audio is empty (type: ${audioBlob.type || "unknown"}, size: ${audioBlob.size} bytes)`);
    }

    const buffer = await audioBlob.arrayBuffer();
    const uint8Array = new Uint8Array(buffer);
    const inputFile = "input.webm";
    const outputFile = "output.mp4";
    await ffmpeg.writeFile(inputFile, uint8Array);

    // exec() resolves with a non-zero code on failure instead of throwing
    const exitCode = await ffmpeg.exec(["-i", inputFile, "-vn", "-c:a", "aac", "-b:a", "128k", outputFile]);
    ffmpeg.off("log", onLog);
    if (exitCode !== 0) {
      console.error("ffmpeg log:\n" + logLines.join("\n"));
      throw new Error(`ffmpeg conversion failed (exit code ${exitCode}) [blob type: ${audioBlob.type || "unknown"}, size: ${audioBlob.size} bytes]: ${logLines.slice(-3).join(" | ")}`);
    }

    const outputData = await ffmpeg.readFile(outputFile);
    await ffmpeg.deleteFile(inputFile).catch(() => { });
    await ffmpeg.deleteFile(outputFile).catch(() => { });

    return new Blob([outputData], { type: "video/mp4" });
  };



  const openCancelBalanceRequestModal = () => {
    setIsModalOpen(true)
    if (cancelBalanceRequestModalRef.current) {
      cancelBalanceRequestModalRef.current.classList.add('show');
      cancelBalanceRequestModalRef.current.style.display = 'block';
    }
  }

  const closeCancelBalanceRequestModal = () => {

    if (cancelBalanceRequestModalRef.current) {
      cancelBalanceRequestModalRef.current.classList.remove('show');
      cancelBalanceRequestModalRef.current.style.display = 'none';
    }
  }

  const formatBookingDate = (dateString) => {
    const date = new Date(dateString);

    const time = date.toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const weekday = date.toLocaleString("en-US", { weekday: "short" });
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${time} on ${weekday} ${day} ${month} ${year}`;
  };

  let billingData = {
    vendor_company_name: vendor?.vendor_company_name,
    vendor_address: vendor?.vendor_address,
    vendor_mbl: vendor?.vendor_mbl,
    order_id: order_id,
    order_date: product?.order_date,
    order_item: orderdetail?.map((item) => ({
      item_name: item.product_name, item_quantity: item.added_count,
      item_price: item?.price,
    })),
    Saved_by: product?.discount_detail?.lable || 'Subtotal (Offer Price)',
    discount_amount: product?.discount_detail?.discount_amount || product?.payment_details?.offer_price || product?.discount_price,
    sub_total: product?.payment_details?.total_amount,
    delivery_charge: product?.delivery_charge,
    user_platform_charges: product?.user_platform_charges,
    round_off: product?.round_off,
    packing_charge: product?.packing_charge,
    total_amount: product?.total_amount,
    delivery_tip: product?.delivery_tip,
    gst_percentage: product?.gst_data?.gst_percentage,
    payment_method: product?.payment_details?.payment_method,
    payment_status: product?.payment_details?.payment_status,
    card_applied_status: product?.card_applied_status,
    applied_card_detail: product?.applied_card_detail,
    offer_details: product?.offer_details
  }

  return (
    <div>
      <div className="min-vh-100">
        <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
          <div className="d-flex justify-content-between align-items-center ms-2 me-2">
            <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => {
              fromPage == "DashBoard" ? navigate("/dashboard") : fromPage == "ReviewPay" ? navigate("/", { state: { fromPage: "ProductPass" } }) : fromPage == "transaction" ? navigate(-1) : navigate("/", { state: { fromPage: "ProductPass" } });
            }} />
            <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
              Product Pass
            </div>
          </div>
        </div>

        {pageLoaded ?
          <div className="servicePassHead scroller-style-y">
            <div className="servicePassCard">
              <div className="">

                {/* <button onClick={() => openCencalConfirmModal()} >Open</button> */}
                <div class="TicketPass-Div">
                  {
                    product?.shipping_type == "2" ?
                      <div className="w3-bar w3-black d-flex justify-content-center w-100">
                        <div class="Switch-T-S nav flex-column nav-pills me-3" id="v-pills-tab"
                          role="tablist" aria-orientation="vertical" className="d-flex justify-content-between"  >
                          <div className="col-6" onClick={() => setTicket_tab('1')}>
                            <button class={`px-5 nav-link   w-100 ff-poppins-semiBold w3-bar-item w3-button ${ticket_tab == 1 ? " active" : ""}`}
                              id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home"
                              type="button" role="tab" aria-controls="v-pills-home" aria-selected="true"  >
                              Ticket
                            </button>
                          </div>
                          <div className="col-6" onClick={() => setTicket_tab('2')}>
                            <button class={`px-5 nav-link   w-100 ff-poppins-semiBold w3-bar-item w3-button ${ticket_tab == 2 ? " active" : ""}`}
                              style={{ paddingRight: 40, paddingLeft: 40 }} id="v-pills-profile-tab" data-bs-toggle="pill"
                              data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" >
                              Schedule
                            </button>
                          </div>
                        </div>
                      </div> : ""
                  }

                  <div class="tab-content col-12" id="v-pills-tabContent">
                    {
                      ticket_tab == 1 ?
                        <div className={`tab-pane  ${ticket_tab == 1 ? "show active" : "fade"} `} >

                          {(product.order_status == 2 || product.delivery_status == 5) ? (
                            <div className="p-2">

                              {
                                product?.shipping_type == 2 ?

                                  !product?.pilot_rating_status || editdeliveryRateing ?
                                    <div className="feedback_box p-3" >
                                      <div className=" text-center">
                                        <h6 className="p-0 m-0 ff-poppins-medium primary-text" >Rate the delivery partner</h6>
                                        <p className="p-0 m-0 ff-poppins-medium fs-10" >Rate the delivery experience!</p>
                                      </div>
                                      <div className="feedback mt-1 mb-1">
                                        {pilotratings.map((filled, index) => (
                                          <div key={index} onClick={() => handlePiltoStarClick(index)}>
                                            {filled ? <IoMdStar color="gold" size={30} /> : <IoIosStarOutline color="gold" size={30} />}
                                          </div>
                                        ))}
                                      </div>
                                      <fieldset className="feedbackInput rounded-3 secondary-border" >
                                        <input placeholder="Enter your review" className="feedbackEnter custom-input bg-white fs-12 text-darl ff-poppins-medium" value={delivery_partner_feedback} onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            e.target.blur();
                                          }
                                        }} maxLength={250} onChange={(e) => setDelivery_partner_feedback(e.target.value)} type="text" />
                                        <button className="form-submit col-2 ff-poppins-medium ouline-none primary-bg fs-10 rounded-1 text-light border-0 p-1" onClick={() => delivery_Partner_rateing()}  >
                                          POST
                                        </button>
                                      </fieldset>
                                    </div>
                                    :
                                    <div className="rounded-3 secondary-border mt-2">
                                      <div className="p-3">
                                        <h6 className="fs-14 ff-poppins-medium p-0 m-0 primary-text">Delivery Rating and Review</h6>
                                        <div className="d-flex justify-content-between mt-1">
                                          <div className="delivery_star d-flex">
                                            {pilotratings.map((filled, index) => (
                                              <div key={index} className="fs-14" >
                                                {filled ? <IoMdStar color="gold" size={25} /> : <IoIosStarOutline color="gold" size={25} />}
                                              </div>
                                            ))}
                                          </div>
                                          <div className="rounded-2 align-self-center text-dark secondary-border text-center fs-12 ff-poppins-semiBold col-2" onClick={() => setEditDeliveryRateing(true)} >
                                            Edit
                                          </div>
                                        </div>
                                        {
                                          delivery_partner_feedback ?
                                            <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text mt-2">{delivery_partner_feedback} </h6> :
                                            <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 mt-2 secondary-text-1">Please provide your feedback.</h6>
                                        }
                                      </div>
                                    </div>
                                  : ""

                              }

                              {
                                !product?.rating_status || editproductRateing ?
                                  <div className="feedback_box p-3" >
                                    <div className=" text-center">
                                      <h6 className="p-0 m-0 ff-poppins-medium primary-text" >Rate the product</h6>
                                      <p className="p-0 m-0 ff-poppins-medium fs-10" >Rate the product experience!</p>
                                    </div>
                                    <div className="feedback mt-1 mb-1">
                                      {ratings.map((filled, index) => (
                                        <div key={index} onClick={() => handleStarClick(index)}>
                                          {filled ? <IoMdStar color="gold" size={30} /> : <IoIosStarOutline color="gold" size={30} />}
                                        </div>
                                      ))}
                                    </div>
                                    <fieldset className="feedbackInput rounded-3 secondary-border ">
                                      <input className="feedbackEnter bg-white fs-12 text-darl ff-poppins-medium custom-input" placeholder="Enter your review" maxLength={250} value={feedback} onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          e.target.blur();
                                        }
                                      }} onChange={(e) => setFeedback(e.target.value)} type="text" />
                                      <button className="form-submit col-2 ff-poppins-medium ouline-none primary-bg fs-10 rounded-1 text-light border-0 p-1" onClick={() => starRating()}  >
                                        POST
                                      </button>
                                    </fieldset>
                                  </div> :
                                  <div className="rounded-3 secondary-border mt-2">
                                    <div className="p-3">
                                      <h6 className="fs-14 ff-poppins-medium p-0 m-0 primary-text">Product Rating and Review</h6>
                                      <div className="d-flex justify-content-between mt-1 mb-1">
                                        <div className="delivery_star d-flex">
                                          {ratings.map((filled, index) => (
                                            <div key={index} className="fs-14" >
                                              {filled ? <IoMdStar color="gold" size={25} /> : <IoIosStarOutline color="gold" size={25} />}
                                            </div>
                                          ))}
                                        </div>
                                        <div className="rounded-2 align-self-center secondary-border text-dark text-center fs-12 ff-poppins-semiBold col-2" onClick={() => setEditProductRateing(true)}>
                                          Edit
                                        </div>
                                      </div>
                                      {
                                        feedback ?
                                          <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text">{feedback} </h6> :
                                          <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 secondary-text-1">Please provide your feedback.</h6>
                                      }
                                    </div>
                                  </div>
                              }
                            </div>
                          ) : (
                            <div className="tab-pane fade show active p-0" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabIndex="0" >
                              {/* no QR for a cancelled order */}
                              {product.order_status != 3 && (
                                <div className="d-flex justify-content-center mt-2">
                                  <img src={product.order_qr} height="60%" width="60%" className="qr-appear" alt="QR Code" />
                                </div>
                              )}
                            </div>

                          )}
                        </div> :
                        ticket_tab == 2 ?
                          <div className={`tab-pane  ${ticket_tab == 2 ? "show active" : "fade"} `}  >
                            <div className="stepper-Box p-3" >
                              {
                                product.delivery_staff_status != true && product.order_status != 3 &&
                                <div className="">
                                  <div className="secondary-box  w-100 rounded-3">
                                    <div className="p-2 d-flex justify-content-between">

                                      <div>
                                        <h6 className="p-0 m-0 ff-poppins-regular primary-text fs-13" >Order Placed</h6>
                                        <p className="p-0 m-0 ff-poppins-regular fs-11">Order preparation will begin shortly.</p>
                                      </div>
                                      <div>
                                        <img src={tick_icon} height="20px" width="20px" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="secondary-box  w-100 rounded-3 mt-2">
                                    <div className="p-2 d-flex justify-content-between">
                                      {
                                        product?.shipping_details ?
                                          <div className=" d-flex justify-content-between w-100">
                                            <div className="col-11">
                                              <h6 className="p-0 m-0 ff-poppins-regular primary-text fs-13" >Courier Assigned</h6>
                                              <p className="p-0 m-0 ff-poppins-regular fs-11">Your order is now assigned for courier delivery </p>
                                            </div>
                                            <div className="col-1">
                                              <img src={tick_icon} height="20px" width="20px" />
                                            </div>
                                          </div>
                                          :
                                          <>
                                            <div>
                                              <h6 className="p-0 m-0 ff-poppins-regular primary-text fs-13" >
                                                {product.delivery_staff_status == true ? "Delivery Staff Assigned."
                                                  : "Assigning Your Delivery Staff Soon"}
                                              </h6>
                                              <p className="p-0 m-0 ff-poppins-regular fs-11">
                                                {
                                                  product.delivery_staff_status == true ? " Your order is now assigned for delivery." :
                                                    " Expect a delivery staff assignment shortly."
                                                }
                                              </p>
                                            </div>
                                            {
                                              product.delivery_staff_status == true ?
                                                <div>
                                                  <img src={tick_icon} height="20px" width="20px" />
                                                </div> :
                                                product?.order_type == "INSTANT" &&
                                                <div class="spinner-border mt-1 primary-text" role="status" style={{ height: "25px", width: "25px" }} >
                                                  <span class="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                          </>
                                      }
                                    </div>
                                  </div>
                                </div>

                              }

                              {
                                deliverystep &&
                                deliverystep.length > 0 && (product.delivery_staff_status == true || product.order_status == 3) && (
                                  <div>
                                    <VerticalStepper steps={deliverystep} />

                                    {/* {product.order_status != 3 && */}
                                    <div className="d-flex justify-content-end" onClick={() => navigate(`/live_traking/${order_id}`)} >
                                      <div className="primary-bg col-5 rounded-2 d-flex justify-content-center align-items-center" style={{ height: "32px" }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <img src={live_tracking_lens} height="12px" width="12px" />

                                          <div className="text-light fs-12 ff-poppins-regular ms-2">
                                            Live Tracking
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                    {/* } */}
                                  </div>
                                )}
                            </div>
                          </div>
                          : ""
                    }
                  </div>
                </div>

              </div>
            </div>
            <div>
              <div>
                <div className="servicePassCard">
                  <div>
                    <div className="headerDivPP d-flex">
                      <div className="col-8 ">
                        <p className="m-0 fs-13 ff-poppins-semiBold">
                          {product.order_date_string}
                        </p>
                        <p className=" fs-15 m-0 ff-poppins-semiBold">
                          Order Id - <span>{product.order_id} </span>
                        </p>
                      </div>
                      {product.order_status == 3 ? (
                        <div className="me-1">
                          <button className="danger-lable fs-12 p-1 ff-poppins-semiBold">Cancelled</button>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <div className="d-flex flex-column align-items-center otpBorderProuductDiv">
                            <div className="otpBorderProuduct"></div>
                          </div>
                          <div className="me-2">
                            <p className="m-0 fs-14 ff-poppins-semiBold">
                              OTP:
                            </p>
                            <p className=" fs-14 m-0 ff-poppins-semiBold">
                              {product.order_code}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>


                  {product.shipping_type == "2" ? (
                    <div>
                      <h6 className="ms-2 m-0 pb-3 fs-16 mb-0 ff-poppins-semiBold">
                        Delivery Address
                      </h6>
                      <div className="addresHeadDivPP">
                        <div className="addressHomeDivPP">
                          <div className="homeIConDivPP">
                            {location.location_type_id == 1 ? (
                              <IoMdHome className="homeIconPP" />
                            ) : location.location_type_id == 2 ? (
                              <MdWork className="homeIconPP" />
                            ) : location.location_type_id == 3 ? (
                              <IoLocationSharp className="homeIconPP" />
                            ) : (
                              <p>No Icon</p>
                            )}
                          </div>
                        </div>

                        <div className="addTextDivPP">
                          <h6 className="ff-poppins-semiBold">
                            {location.location_type}
                          </h6>
                          <h6 className="addressTextPP fs-12 m-0 ff-poppins-regular numberOfLines">
                            {location.address}
                          </h6>
                          <h6 className="addressTextPP fs-12 m-0 ff-poppins-regular">
                            {`${(location.distance?.text || "").substring(0, 10)}-${(location.duration?.text || "").substring(0, 10)}`}
                          </h6>
                        </div>
                        <div className="arrowDivPP">
                          <IoIosArrowForward />
                        </div>
                      </div>

                      {
                        product.shipping_details &&
                        <div>
                          <h6 className="ms-2 m-0 mt-2 fs-16 mb-0 ff-poppins-semiBold">
                            Courier  Delivery
                          </h6>

                          <div className="bookForHeadDivRP ">
                            <div className="staffCardHead rounded-3">
                              <div>
                                <h6 className=" fs-14 mb-0 ff-poppins-semiBold">{product.shipping_details.courier_name}</h6>
                                <p className="fs-12 ff-poppins-regular p-0 mt-1 m-0"> Courier delivery, at your door on time !</p>
                              </div>
                            </div>

                          </div>
                        </div>
                      }

                      {
                        !product.shipping_details &&
                        <>
                          <div className="secondary-box rounded-3 mt-2">
                            <div className="p-2">
                              {(() => {
                                const tabs = [
                                  { id: 1, label: "Delivery Type" },
                                  { id: 3, label: "Instructions" },
                                ];

                                const tabCount = tabs.length;
                                const activeIndex = tabs.findIndex((t) => t.id === delivery_option);

                                return (
                                  <div className="secondary-bg-4 rounded-4" style={{ padding: '6px 8px', display: "flex", justifyContent: "center" }}>
                                    <div className="Tab-container">
                                      <div
                                        className="highlight"
                                        style={{
                                          width: `${100 / tabCount}%`,
                                          transform: `translateX(${activeIndex * 100}%)`
                                        }}
                                      ></div>

                                      {tabs.map((tab) => (
                                        <div
                                          key={tab.id}
                                          className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option === tab.id ? "text-white" : ""}`}
                                          onClick={() => setDelivery_option(tab.id)}
                                        >
                                          {tab.label}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                );
                              })()}

                              {

                                delivery_option == 1 ?
                                  <div className="mt-4">
                                    {product.shipping_type == '2' ?
                                      <div className="d-flex justify-content-between align-items-center secondary-box  rounded-3 p-2">
                                        <div className="p-1">
                                          {
                                            product?.delivery_slot_type == '2' ?
                                              <>
                                                <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Any Time</h6>
                                                <p className="p-0 m-0 fs-10 ff-poppins-regular">This product will be delivered within <span className="primary-text">3 days</span>   </p>
                                              </>
                                              : product?.delivery_slot_type == '1' ?
                                                <>
                                                  <h6 className="p-0 m-0 fs-12    ff-poppins-semiBold">Slot Delivery</h6>
                                                  <p className="p-0 m-0 fs-11    ff-poppins-medium">Slot delivery,at your door on time   </p>
                                                  <p className="p-0 m-0 fs-11    ff-poppins-medium primary-text">{product?.order_delivery_date_time?.delivery_time}  {new Date(product?.order_delivery_date_time?.delivery_date.substring(0, 10)).toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", }).replace(",", "")} </p>

                                                </> : product?.delivery_slot_type == '3' ?
                                                  <>
                                                    <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Instant Delivery</h6>
                                                    <p className="p-0 m-0 fs-10 ff-poppins-regular">At your door in <span className="primary-text">30 minutes!</span>   </p>
                                                  </> : ""
                                          }
                                          {product?.change_delivery_detail?.request_status == '3' &&
                                            <p className="ff-poppins-medium fs-10 text-danger p-0 m-0 mt-1">
                                              The merchant has cancelled your request to change the delivery option.
                                            </p>}
                                        </div>

                                        {
                                          payment.payment_method != '4' && product?.change_delivery_detail == null || product?.change_delivery_detail?.request_status == '' ?
                                            <div>
                                              <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14" onClick={() => { setChangeDeliveryTypeModal(!changeDeliveryTypeModal) }}>Change</p>
                                            </div> : ""
                                        }
                                      </div> : ""
                                    }
                                  </div>
                                  :
                                  delivery_option == 3 ?
                                    <div>
                                      <div className="cursorDefault">
                                        <p className="text-center fs-11 p-0 m-0  ff-poppins-regular mt-2">Add delivery instructions for a smooth drop-off!</p>
                                        <div className="d-flex scroller-style-x">
                                          {(() => {
                                            const allOptions = [
                                              { id: 1, icon: bell_icon, label: "Don't ring the bell" },
                                              { id: 2, icon: door_icon, label: "Leave at the door" },
                                              { id: 3, icon: Avoid_call, label: "Avoid calling" },
                                              { id: 4, icon: gurard_icon, label: "Leave at the guard" },
                                              { id: 5, icon: pet_foot, label: "Pet at home" }
                                            ];

                                            const filteredOptions =
                                              instructionsOption?.order_notes?.delivery_instructions?.length > 0
                                                ? allOptions?.filter((option) =>
                                                  instructionsOption?.order_notes?.delivery_instructions?.includes(option?.label))
                                                : allOptions;


                                            return (
                                              <div className="d-flex mt-3 overflow-auto scroller-style-x">
                                                {filteredOptions?.map((option) => (
                                                  <div
                                                    key={option.id}
                                                    className={`${instructionsOption?.includes(option.label) ? "select-primary-box" : ""
                                                      } Instructions-box mx-1`}
                                                    onClick={() => handleOptionToggle(option.label)}
                                                  >
                                                    <img src={option.icon} alt={option.label} className="instrctionIcons" />
                                                    <p className="fs-10 ff-poppins-semiBold p-0">{option.label}</p>
                                                  </div>
                                                ))}
                                              </div>
                                            );
                                          })()}
                                        </div>


                                        <div className="d-flex justify-content-between mt-2">

                                          {recordedAudio || consulation ?
                                            <div className="addedInstructionContainer d-flex justify-content-between align-center w-100 p-2" onClick={() => openinstructionsModal()} >
                                              <div className="addedInstrcRight ff-poppins-semiBold d-flex align-center gap-1">
                                                <span className="fs-12 primary-text"> <MdEditDocument /></span>
                                                Edit instructions
                                              </div>
                                            </div>
                                            :
                                            <div className="mt-1">
                                              <p className="p-0 m-0 fs-12 ms-2 ff-poppins-semiBold  primary-text" onClick={() => openinstructionsModal()}>+  Add an instructions note</p>
                                            </div>
                                          }
                                          {hasInstructionChanges() && (
                                            <div className="InstructionsSendBtn" onClick={() => handleSendInstructions(2)}  >
                                              <div className="d-flex align-items-center gap-1">
                                                <span>Send</span>
                                                <IoSend size={12} />
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div> : ""
                              }
                            </div>
                          </div>

                          <h6 className="ms-2 m-0 pt-3 fs-16 ff-poppins-semiBold"> Delivery Staff </h6>

                          <div className="bookForHeadDivRP">
                            {product.delivery_staff_status == true ? (
                              <div className="staffCardHead rounded-4">
                                <div className="col-3">
                                  <div className="staffProfileDiv">
                                    {
                                      staff?.delivery_staff_type == "Flyer" ?
                                        <img src={staff.staff_image == "" ? defaultperson : staff.pingledel_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="petProfileRP" />
                                        :
                                        staff?.delivery_staff_type == "Pilot" ?
                                          <img src={staff.pilot_image == "" ? defaultperson : staff.pilot_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="petProfileRP" />
                                          :
                                          <img src={staff.staff_image == "" ? defaultperson : staff.staff_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="petProfileRP" />
                                    }
                                  </div>
                                </div>
                                <div className="col-9 staffContentHeadDiv">
                                  <span className="fs-14 ff-poppins-semiBold m-0">{staff?.delivery_staff_type == "Flyer" ? staff.name : staff?.delivery_staff_type == "Pilot" ? staff.pilot_name : staff.staff_name}</span>
                                  <div className="ff-poppins-regular secondary-text-1 fs-12 m-0"> {staff?.delivery_staff_type == "Flyer" ?
                                    staff.phone_number : staff?.delivery_staff_type == "Pilot" ? staff?.phone_number : staff?.staff_designation}</div>
                                  <div>
                                    {showStaffDetails ? (
                                      <div className="staffAboutDiv">
                                        <span className="staffSpecializationText fs-12 m-0 ff-poppins-regular">  {staff.staff_specialist}  </span>
                                        <hr className="staffHr" />
                                        <p className="staffAboutStaff fs-12 ff-poppins-regular">
                                          {
                                            staff?.delivery_staff_type == "Flyer" ? staff.about :
                                              staff?.delivery_staff_type == "Pilot" ? staff?.about :
                                                staff?.staff_about
                                          }
                                        </p>
                                        <div className="moreInfoDiv" onClick={toggleStaffDetails} >
                                          <span className="  fs-13 p-0 m-0 ff-poppins-semiBold">
                                            Less info
                                          </span>
                                          <IoIosArrowDropupCircle className="primary-text ms-1" />
                                        </div>
                                      </div>
                                    ) : (
                                      // <div className="moreInfoDiv" onClick={toggleStaffDetails} >
                                      //   <span className=" peimary-text fs-13 p-0 mt-1 ff-poppins-semiBold">  More info  </span>
                                      //   <IoIosArrowDropdownCircle className="primary-text ms-1" />
                                      // </div>
                                      <div className="moreInfoDiv" onClick={toggleStaffDetails}>
                                        <p className="moreInfoText  p-0 m-0 ff-poppins-semiBold">More info</p>
                                        <IoIosArrowDropdownCircle className="primary-text ms-1" />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className=" ff-poppins-semiBold staffCardHead fs-13 d-flex justify-content-center border border-2 rounded-3">
                                <p className="align-self-center mt-3"> Staff not assign  </p>
                              </div>
                            )}
                          </div>
                        </>
                      }
                    </div>
                  ) : (
                    <></>
                  )}
                  {/* {
                  product?.delivery_slot_status == '1' ?
                    < div className="mt-2">
                      <div className="border border-2 rounded-3">
                        <div className="p-2">
                          <div className="d-flex justify-content-start primary-text">
                            <span className="ff-balooPaaji2-semiBold fs-16 mt-1">Delivery Time</span>
                          </div>
                          <p className="fs-12 ff-poppins-regular secondary-text m-0">Choose time when order will be delivered</p>
                          <hr />
                          {
                            product?.delivery_slot_type == '2' ?
                              <div className="d-flex justify-content-center">
                                <p className="ff-poppins-semiBold fs-14 m-0 primary-text">Any Time Delivery</p>
                              </div> :
                              <div className="d-flex justify-content-between">
                                <div className="d-flex justify-content-around col-4 ff-poppins-regular">
                                  <div className="me-1 primary-text ff-balooPaaji2-semiBold">
                                    <CiCalendar />
                                  </div>
                                  <div className="fs-12 mt-1">
                                    {new Date(product?.order_delivery_date_time?.delivery_date.substring(0, 10)).toDateString().substring(4, 20)}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-around col-4 ff-poppins-regular">
                                  <div className="fs-12">
                                    <span className="me-1 primary-text ff-balooPaaji2-semiBold">
                                      <BsClock />
                                    </span>
                                    {product?.order_delivery_date_time?.delivery_time}
                                  </div>
                                </div>
                              </div>

                          }

                        </div>
                      </div>
                    </div> : <></>
                } */}
                  {product?.shipping_type != 2 &&
                    <div>
                      <h6 className="fs-14 ff-poppins-bold">Delivery Option</h6>
                      <div className="deliveryOptionSelectedBox  ">

                        <div>
                          {
                            product?.shipping_type == 0 ?
                              <>

                                <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold"> Dine-in</h6>
                                <p className="p-0 m-0 fs-10 ff-poppins-regular">Convenient dine-in service</p>
                              </> :
                              product?.shipping_type == 1 ?
                                <>
                                  <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Instore pickup </h6>
                                  <p className="p-0 m-0 fs-10 ff-poppins-regular">Hassle-free in-store pickup </p>
                                </> :
                                ''
                          }
                          {product?.change_delivery_detail?.request_status == '3' &&
                            <p className="ff-poppins-medium fs-10 text-danger p-0 m-0 mt-1">
                              The merchant has cancelled your request to change the delivery option.
                            </p>}

                        </div>
                        {
                          payment.payment_method != '4' && product?.change_delivery_detail == null || product?.change_delivery_detail?.request_status == '' ?
                            <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14"
                              onClick={() => { setChangeDeliveryTypeModal(!changeDeliveryTypeModal) }} >Change</p> : ''
                        }

                      </div>
                    </div>

                  }
                  <h6 className="ms-2 m-0 pt-3 ff-poppins-semiBold">
                    Booking For
                  </h6>

                  <div className="bookForHeadDivRP">
                    <div className="staffCardHead rounded-4">
                      <div className="col-3">
                        <div className="staffProfileDiv">
                          <img src={user?.user_img} className="petProfileRP" />
                        </div>
                      </div>

                      <div className="col-9 staffContentHeadDiv">
                        <span className=" fs-13 ff-poppins-semiBold">{user?.user_name}</span>
                        <div className='ff-poppins-regular secondary-text-1 fs-12 m-0'>Myself</div>
                        {showDetails ? (
                          <div className="staffAboutDiv">
                            <p className="staffSpecializationText fs-12 m-0 ff-poppins-regular">
                              {user?.about}
                            </p>
                            <div className="moreInfoDiv" onClick={toggleDetails} >
                              <p className="moreInfoText  p-0 m-0 ff-poppins-semiBold">Less info</p>
                              <IoIosArrowDropupCircle className="primary-text ms-1" />
                            </div>
                          </div>
                        ) : (
                          <div className="moreInfoDiv" onClick={toggleDetails}>
                            <p className="moreInfoText  p-0 m-0 ff-poppins-semiBold">More info</p>
                            <IoIosArrowDropdownCircle className="primary-text ms-1" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="d-flex SPCard" >
                      <div className="col-3" onClick={() => navigate(`/vendor/${vendor?.vendor_id}`)}>
                        <img src={vendor?.vendor_logo} className="followerImage" alt="No Follower Profile" />
                      </div>
                      <div className="col-7" onClick={() => navigate(`/vendor/${vendor?.vendor_id}`)}>
                        <div className="followerDetDiv">
                          <div className="ff-poppins-semiBold fs-14 name_overflow" >{vendor?.vendor_company_name}</div>
                          <div className="ff-poppins-medium fs-12 text-secondary">&#x2022; MID {vendor?.vendor_id} </div>
                          <div className="ff-poppins-medium fs-12 text-secondary">&#x2022; {vendor?.vendor_type_name} </div>
                          <div className="ff-poppins-medium fs-12 text-secondary singleline-text">&#x2022; {vendor?.vendor_address} </div>
                        </div>
                      </div>
                      <div className="col-2 FollowerHistoryDiv" onClick={() => navigate(`/history/${vendor.vendor_id}`)} >
                        <FaHourglassHalf className="hourClassIConFollower" />
                        <p className="followerHistoryP">History</p>
                      </div>
                    </div>
                  </div>

                  <div className="FHSIConsSP">
                    <div className="d-flex align-items-center">
                      <a href={`tel:${vendor?.vendor_mbl}`} className="text-decoration-none" >
                        <div className="d-flex justify-content-center align-items-center contactDetails">
                          <PiPhoneCallFill className="IconsFHSSP" />
                          <div className="ms-2 ff-poppins-semiBold fs-14 text-white">
                            Call
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="hourGlassIconSP">
                      <div className="d-flex align-items-center" onClick={() => navigate(`/chat/booking/${order_id}`, { state: { chatFlow: 'order' } })}  >
                        <BiMessageDetail className="IconsFHSSP" />
                        <p className="m-0 ms-2 ff-poppins-semiBold">Text</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center " onClick={() => copyToClipboard()} >
                        <RiShareFill className="IconsFHSSP" />
                        <p className="m-0 ms-2 ff-poppins-semiBold">Share</p>
                      </div>
                    </div>
                  </div>
                  {
                    product?.card_applied_status == 1 && product?.applied_card_detail.card_type == "coupon" ?
                      <>
                        <h6 className="ff-poppins-semiBold  fs-15 mt-2">Coupons</h6>
                        <div className="secondary-box mb-1 p-2  d-flex justify-content-between align-items-center rounded-3" >
                          <div className="d-flex align-items-center h-100">
                            <img src={apply_coupon} height="16px" width="20px" className=" ms-2" />
                            <span className="fs-14 ms-2 ff-poppins-semiBold"> {product.applied_card_detail.coupons_code}  </span>
                          </div>
                          <span className="fs-10 mt-1 rounded-4 text-center ms-2 ff-poppins-regular applied_lable">Applied</span>
                        </div>
                      </>
                      : ""
                  }
                  <div>

                    <div className="d-flex justify-content-between align-items-center mt-3 h-100 cursor-pointer" >
                      <span className="bookInfoTextRP ff-poppins-semiBold d-flex fs-15 mb-0"> Billing Information </span>
                      <span  > <DownLossdbillingPDF data={billingData} /></span>
                    </div>

                    <p className="ff-poppins-regular fs-11 p-0 m-0 mt-2">
                      Booking initiated at{" "} {formatBookingDate(product.order_date)}
                      {product?.order_date_string} by {user.user_name}
                    </p>



                    <div className="mt-2">
                      {product?.applied_card_detail?.offer_type == "3" ? (
                        <div className="">
                          <h6 className="ff-poppins-semiBold primary-text fs-15">  Buy Products </h6>
                          {buyproduct?.map((list, index) => {
                            return (
                              <div className="offerServiceProduct">
                                <span> {list?.product_name}</span>
                                <span> {list?.added_count} x {list?.price}  </span>
                              </div>
                            );
                          })}
                          <div className="totalBar ff-poppins-regular d-flex justify-content-between  mt-3">
                            <span className="fs-12 ff-poppins-medium mt-1 mb-1 text-success">Total (Offer Price)</span>
                            <span className="fs-12 ff-poppins-medium mt-1 mb-1 text-success">  Rs.{product?.offer_details?.buy_products_total}.00 </span>
                          </div>

                          <h6 className="ff-poppins-semiBold primary-text fs-15 mt-4">
                            Get Products(Free)
                          </h6>
                          {getproduct?.map((list, index) => {
                            return (
                              <div className="offerServiceProduct">
                                <span > {list?.product_name}</span>
                                <span > {list?.added_count} x {list?.price}  </span>
                              </div>
                            );
                          })}
                          <div className="totalBar ff-poppins-regular d-flex justify-content-between  mt-3">
                            <span className="fs-12 ff-poppins-medium mt-1 mb-1 text-success">Total (Free Value)</span>
                            <span className="fs-12 ff-poppins-medium mt-1 mb-1 text-success">  Rs.{product?.offer_details?.get_products_total}.00 </span>
                          </div>
                        </div>
                      ) : (
                        <div>
                          {
                            product?.pre_order_status == 1 ?
                              <h6 className="serviceTextRP ff-poppins-semiBold">Preorder Details</h6> :
                              <h6 className="serviceTextRP ff-poppins-semiBold">Products</h6>
                          }
                          {
                            product?.pre_order_status == 1 &&
                            <div className="d-flex justify-content-between ff-poppins-regular fs-13" >
                              <span className="m-0 ff-poppins-regular">  {product?.pre_order_ticket?.ticket_name}  </span>
                              <span className="m-0 ms-2 ff-poppins-regular">
                                {product?.pre_order_ticket?.redeem_validity}
                              </span>
                            </div>
                          }
                          {
                            orderdetail &&
                            orderdetail?.map((products, index) => {
                              return (
                                <div>
                                  <div className="d-flex justify-content-between ff-poppins-regular fs-12" key={index}  >
                                    <p className="m-0 ff-poppins-regular">  {products?.product_name}  </p>
                                    <div className="d-flex">
                                      {
                                        products?.added_addons_details?.length > 0 ?
                                          <div onClick={() => toggleAddon(index)} style={{ cursor: 'pointer' }}>
                                            {showAddonsState[index] ? (
                                              <SlArrowUp className="me-2" />
                                            ) : (
                                              <SlArrowDown className="me-2" />
                                            )}
                                          </div>
                                          : ""
                                      }
                                      <p className="m-0 ms-1 p-0 ">
                                        {products?.added_count} x {
                                          (Number(products?.price || 0) + Number(products?.addons_cost || 0)).toFixed(2)
                                        }

                                      </p>
                                    </div>
                                  </div>

                                  <div className="m-0 fs-11 ff-poppins-regular col-10">
                                    {showAddonsState[index] ? (
                                      products?.added_addons_details?.map((addon, addonIndex) => (
                                        <div key={addonIndex} className="mt-1 d-flex justify-content-between ff-poppins-regular fs-11">
                                          <div>{addon?.addon_name} - {addon?.name}</div>
                                          <div>{products?.added_count} x {addon?.price}</div>
                                        </div>
                                      ))
                                    ) : (
                                      products?.added_addons_details?.length > 0 && (
                                        <>({products.added_addons_details.map((addon) => addon.name.trim()).join(', ')})</>
                                      )
                                    )}
                                  </div>
                                </div>
                              );
                            })
                          }



                          {product?.card_applied_status == "1" ? (
                            <div className="totalBar fs-13 m-0 p-1 mt-2">
                              {
                                product?.applied_card_detail?.offer_type == 4 ?
                                  <div className="d-flex justify-content-between">
                                    <p className="m-0 ff-poppins-regular fs-12 text-success"> Subtotal (Offer Price)</p>
                                    <p className="m-0 ff-poppins-regular fs-12 text-success"> Rs.{product?.applied_card_detail?.offer_price}</p>
                                  </div> :
                                  product?.discount_status == "1" ? (
                                    <div className="d-flex justify-content-between">
                                      <p className="m-0 ff-poppins-regular fs-12 text-success"> {product?.discount_detail?.lable}{" "}
                                        {product?.applied_card_detail?.discount ?
                                          `(${product?.applied_card_detail?.discount_type == "2" ? `${product?.applied_card_detail?.discount}%` : `₹${product?.applied_card_detail?.discount}`})`
                                          : ""}
                                      </p>
                                      <p className="m-0 ff-poppins-regular fs-12 text-success"> Rs.{product?.discount_detail?.discount_amount}</p>
                                    </div>
                                  ) : (
                                    product?.discount_price &&
                                    <div className="d-flex justify-content-between">
                                      <p className="m-0 ff-poppins-regular fs-12 text-success">Total</p>
                                      <p className="m-0 ff-poppins-regular fs-12 text-success"> Rs.{product?.discount_price}  </p>
                                    </div>
                                  )}

                            </div>
                          )
                            : (
                              <div style={{ borderBottomColor: "gray", borderBottomWidth: 2, borderBottomStyle: "dashed", marginTop: 10, }}></div>
                            )}
                        </div>
                      )}
                    </div>
                    {
                      product?.redeemed_loyalty?.loyalty_status == "1" ?
                        <div className="ff-poppins-regular fs-13 mt-2">
                          <div className="d-flex justify-content-between">
                            <p className="m-0 fs-12 ff-poppins-regular">Subtotal</p>
                            <p className="m-0 fs-12 ff-poppins-regular">
                              {product.sub_toatl}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between">
                            <p className="m-0 fs-12 ff-poppins-regular">Pingle Points redeemed {'(' + product?.redeemed_loyalty?.loyalty_points + ')'}</p>
                            <p className="m-0 fs-12 ff-poppins-regular">  - {product.sub_toatl}  </p>
                          </div>
                        </div>
                        :
                        <div className="servicePriceHeadDiv dashBorderRP ff-poppins-regular fs-13">
                          {
                            product?.pre_order_status == 1 ?
                              <div className="d-flex justify-content-between">
                                <p className="m-0 fs-12 ff-poppins-regular">Preorder amount</p>
                                <p className="m-0 fs-12 ff-poppins-regular">
                                  {product?.pre_order_ticket.ticket_price}
                                </p>
                              </div>
                              :
                              product?.applied_card_detail?.offer_type != 4 &&
                              <div className="d-flex justify-content-between">
                                <p className="m-0 fs-12 ff-poppins-regular">Subtotal</p>
                                <p className="m-0 fs-12 ff-poppins-regular">
                                  {product.sub_toatl}
                                </p>
                              </div>

                          }
                          {product.delivery_charge_status == true ?
                            <div className="d-flex justify-content-between">
                              <p className="m-0 fs-12 ff-poppins-regular"> Delivery Charge</p>
                              <p className="m-0 fs-12 ff-poppins-regular">
                                {product.delivery_charge}
                              </p>
                            </div>
                            : ""
                          }
                          {
                            product?.shipping_type != 0 && product.packing_charge ?
                              <div className="d-flex justify-content-between">
                                <p className="m-0 fs-12 ff-poppins-regular">Packing Cost</p>
                                <p className="m-0 fs-12 ff-poppins-regular">
                                  {product.packing_charge}
                                </p>
                              </div> : ""
                          }
                          {/* <div className="d-flex justify-content-between">
                            <p className="m-0 fs-12 ff-poppins-regular">Packing Cost</p>
                            <p className="m-0 fs-12 ff-poppins-regular">
                              {product.packing_charge}
                            </p>
                          </div> */}

                          <div className="d-flex justify-content-between">
                            <p className="m-0 fs-12 ff-poppins-regular"> Platform Charge</p>
                            <p className="m-0 fs-12 ff-poppins-regular">
                              {product.user_platform_charges}
                            </p>
                          </div>
                          {
                            product?.delivery_tip && product?.delivery_tip != 0 &&
                            <div className="d-flex justify-content-between">
                              <p className="m-0 fs-12 ff-poppins-regular">Delivery Tip</p>
                              <p className="m-0 fs-12 ff-poppins-regular">
                                {product.delivery_tip}
                              </p>
                            </div>
                          }
                          {gststatus == true ? (
                            <div>
                              <div className="d-flex justify-content-between">
                                <p className="m-0 fs-12 ff-poppins-regular"> SGST</p>
                                <p className="m-0 fs-12 ff-poppins-regular">
                                  {product.sgst_amount}
                                </p>
                              </div>
                              <div className="d-flex justify-content-between">
                                <p className="m-0 fs-12 ff-poppins-regular"> CGST </p>
                                <p className="m-0 fs-12 ff-poppins-regular">
                                  {product.cgst_amount}
                                </p>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {product.round_off != 0 ? (
                            <div className="d-flex justify-content-between ff-poppins-regular fs-12">
                              <p className="m-0 p-0">Round Off</p>
                              <p className="m-0 p-0">{product.round_off}</p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                    }
                    {/* {
                    
                    <div className="d-flex justify-content-between">
                    <p className="m-0 ff-poppins-regular">Delivery</p>
                    <p className="m-0 ff-poppins-regular">
                      {product.sub_toatl}
                    </p>
                  </div>
                  
                  } */}

                    <div className="dashBorderRP"></div>

                    {
                      // cash after delivery
                      payment.payment_method == '1' ?
                        <div className="ff-poppins-semiBold mt-2 fs-14 border-Bottom-Dashed">
                          <div className="d-flex justify-content-between">
                            <p className="fs-14 ff-poppins-semiBold">Total</p>
                            <p className="d-flex me-2 fs-14">
                              {payment.payment_status == 0 ? (
                                <button className="unpaidbtn me-2 fs-10 ff-poppins-semiBold ">
                                  UNPAID
                                </button>
                              ) : (
                                <button className="paidBtnSP me-2 fs-10 ff-poppins-semiBold">
                                  PAID
                                </button>
                              )}
                              Rs.{product.total_amount}
                            </p>
                          </div>
                        </div>
                        : payment.payment_method == '2' ?
                          <div className="ff-poppins-semiBold mt-3 fs-15">
                            <div className="d-flex justify-content-between">
                              <p className="">Total</p>
                              <p className="d-flex me-2 fs-14">
                                {payment.payment_status == 0 ? (
                                  <button className="unpaidbtn me-2 fs-12 ff-poppins-semiBold ">
                                    UNPAID
                                  </button>
                                ) : (
                                  <button className="paidBtnSP me-2 fs-12 ff-poppins-semiBold">
                                    PAID
                                  </button>
                                )}
                                Rs.{product.total_amount}
                              </p>
                            </div>
                          </div>
                          :
                          payment.payment_method == '3' ?
                            <div>
                              <div className="ff-poppins-semiBold mt-3 fs-15">
                                <div className="d-flex justify-content-between">
                                  <p className="">Total</p>
                                  <p className="d-flex me-2 fs-14">
                                    Rs.{editOrder?.request_status == "4" ? (Number(payment.advance_amount ?? payment.initial_payment_amount) + Number(payment.balance_amount)) : product.total_amount}
                                  </p>
                                </div>
                              </div>
                              <div className="ff-poppins-semiBold fs-15">
                                <div className="d-flex justify-content-between">
                                  <p className="">Advance amount</p>
                                  <p className="d-flex me-2 fs-14">
                                    <button className="paidBtnSP fs-12 ff-poppins-semiBold me-1">
                                      PAID
                                    </button>
                                    Rs.{payment.advance_amount ?? payment.initial_payment_amount}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <p className="">Balance amount</p>
                                  <p className="d-flex me-2 fs-14">
                                    {(payment.balance_status ?? payment.balance_payment_status) == 0 ? (
                                      <button className="unpaidbtn fs-12 ff-poppins-semiBold me-1">
                                        UNPAID
                                      </button>
                                    ) : (
                                      <button className="paidBtnSP fs-12 ff-poppins-semiBold me-1">
                                        PAID
                                      </button>
                                    )}
                                    Rs.{payment.balance_amount}
                                  </p>
                                </div>
                              </div>
                            </div> :
                            payment.payment_method == '4' ?
                              <div className="ff-poppins-semiBold mt-2  fs-14 border-top-Dashed">
                                <div className="d-flex justify-content-between mt-2" >
                                  <p className="">Total</p>
                                  <p className="d-flex me-2 fs-14">
                                    Rs.0
                                  </p>
                                </div>
                              </div>
                              : <></>
                    }

                    {product.order_status == 3 ? (
                      <div className="mt-3">
                        <h6 className="m-0 ff-poppins-semiBold fs-12"> Cancel Information   </h6>
                        <p className="fs-10 m-0 p-0 ff-poppins-regular">{cancelorder.cancel_description
                          ? cancelorder.cancel_description.charAt(0).toUpperCase() + cancelorder.cancel_description.slice(1)
                          : ''}
                        </p>

                        {
                          cancelorder.refund_description ?
                            <>
                              <h6 className="m-0 ff-poppins-semiBold fs-12 mt-2">Refund Information</h6>
                              <p className="fs-10 m-0 p-0 ff-poppins-regular">{cancelorder.refund_description ? cancelorder.refund_description : ''} </p>

                              {

                                cancelorder.refund_status == "1" &&
                                <div className="mt-2">
                                  <h6 className="m-0 ff-poppins-semiBold fs-12">Refund Status</h6>
                                  <p className="fs-10 m-0 p-0 ff-poppins-regular">
                                    {cancelorder.refund_process_status == "1" ? (
                                      "Refund Processing"
                                    ) : cancelorder.refund_process_status == "2" ? (
                                      "Refund Complete"
                                    ) : cancelorder.refund_process_status == "3" ? (
                                      "Refund Faild"
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                </div>
                              }
                            </>
                            :
                            <p className="fs-12 m-0 p-0 ff-poppins-semiBold mt-2">
                              Refund details are being processed. Please check back shortly...  </p>
                        }
                      </div>
                    ) : (
                      <></>
                    )}
                    {product.dispute == true ?
                      <div>
                        <div>
                          <h5 className="fs-14 ff-poppins-medium  m-0">Dispute Status</h5>
                          <p className="secondary-text-1 p-0 m-0 fs-11 ff-poppins-regular">  {product?.dispute_detail?.dispute_status_name} </p>
                        </div>
                        <div>
                          <h5 className="fs-14 ff-poppins-medium m-0 mt-2 ">Dispute description</h5>
                          <p className="secondary-text-1 p-0 m-0 fs-11 ff-poppins-regular">{product?.dispute_detail?.dispute_description} </p>
                        </div>
                        <div>
                          <h5 className="fs-14 ff-poppins-medium m-0 mt-2">Dispute reason</h5>
                          <p className="secondary-text-1 p-0 m-0 fs-11 ff-poppins-regular text-break">{product?.dispute_detail?.dispute_reason} </p>
                        </div>
                      </div> : <></>
                    }
                  </div>
                </div>
              </div>{" "}


              {product.order_status == 1 && product.delivery_status <= 4 &&
                <div className=" rounded-3 bg-light d-flex justify-content-between align-items-center mt-3 p-2" onClick={() => getrefund()}>
                  <button className="bg-white border border-0 fs-14 secondary-text-2 ff-poppins-semiBold" >
                    Cancel
                  </button>
                  <IoIosArrowForward />
                </div>
              }


              <a href="https://pingle.in/user/refund-policy.php" className="text-dark text-decoration-none fs-14 mt-1 text-center ff-poppins-medium" target="_blank" rel="noopener noreferrer">
                <div className="text-center fs-10 mb-3 mt-2">
                  Read our <span className="primary-text">Cancellation Policy</span> and <span className="primary-text">Refund Policy</span>
                </div>
              </a>


            </div>
            {
              product.dispute == false ?
                <div>
                  <p className="primary-text p-0  text-center fs-14 ff-poppins-semiBold mt-2" onClick={openDisputeModal}>Raise Dispute</p>
                </div>
                : <></>
            }



          </div>
          :
          <div className='d-flex justify-content-center skeleton-bg'>
            <div >
              <Skeleton height={40} width={320} style={{ marginBottom: "10px" }} />
              <Skeleton height={250} width={320} style={{ marginBottom: "20px" }} />
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                  <Skeleton height={90} width={90} style={{ borderRadius: "12px" }} />
                  <div style={{ marginLeft: "20px" }}>
                    <Skeleton height={30} width={180} style={{ marginBottom: "5px" }} />
                    <Skeleton height={20} width={220} style={{ marginBottom: "5px" }} />
                    <Skeleton height={20} width={220} />
                  </div>
                </div>
              ))}

            </div>
          </div>
        }

        <div class="offcanvas mainModal CancelProduct cancelBtnModalProductPass" style={{ position: "sticky !important", minHeight: "55px !important", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}
          tabindex="-1" aria-labelledby="offcanvasBottomLabel" ref={cancelRefundModalRef} >
          <div className="refundContentModal mb-2 refundModal">
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-center">
                <p className="m-0 ff-poppins-semiBold fs-14">Cancel Product</p>
              </div>
              <div onClick={() => closeCancelmodal()} >
                <p className="ff-balooPaaji2-semiBold p-2 m-0 pg-primary"   >
                  <IoMdCloseCircle />
                </p>
              </div>
            </div>
            {
              payment.payment_method == '4' ?

                <>
                  <p className="m-0 fs-12 ff-poppins-regular" >
                    Are you sure you want to cancel the product and get refund ? <br></br>
                    Please note that loyalty points once redeemed will not be refunded or credited back.
                  </p>

                  <p className="mt-3 mb-1 ff-poppins-semiBold fs-14"> Refund Status </p>
                  <p className="m-0 mb-2 ff-poppins-regular fs-12">No refund is applicable for loyalty-redeemed orders</p>
                </> :
                <>
                  <p className="m-0 fs-12 ff-poppins-regular" >
                    Are you sure you want to cancel the product and get refund ? <br></br>
                    Please  read the read the refund policy before clicking the 'confirm'
                    button.
                  </p>

                  <p className="mt-3 mb-1 ff-poppins-semiBold fs-14"> Refund amount </p>
                  <p className="m-0 mb-2 ff-poppins-regular fs-12">{refund}</p>
                </>
            }


            <Link to={"https://pingle.in/user/refund-policy.php"} className="text-dark text-decoration-none fs-14 text-center"   >
              <div className="text-center ff-poppins-regular fs-12">
                Read our{" "}
                <span className="primary-text"> Cancellation Policy </span> and{" "}
                <span className="primary-text">Refund Policy</span>
              </div>
            </Link>
          </div>
          <button className="text-center text-white rescheduleCancelBtnPP ff-poppins-semiBold"
            style={{ marginTop: 15, position: "relative", padding: "10px 20px", backgroundColor: "#primary-bg", color: "white", border: "0px", borderRadius: "5px", height: "40px", lineHeight: "20px", verticalAlign: "middle", }}
            onClick={() => cancel_order(1)} disabled={buttonClicked} >
            {loading && (
              <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", paddingTop: 10, paddingBottom: 10, }} >
                <Loading type="spinningBubbles" color="#fff" height={20} width={20} />
              </div>
            )}
            {!loading && "Confirm"}
          </button>

        </div>




        {deliveryTypeModal &&
          <div className="offcanvas offcanvas-bottomm modal-top-radies main" tabIndex="-1" aria-labelledby="offcanvasBottomLabel"
            ref={deliverypersonunavailableRef} style={{ maxHeight: '60vh', zIndex: 1045 }}     >
            <div className="offcanvas-body small bg-light position-relative">

              <div className="p-1">
                <div>
                  <div className="primary-gradient-box text-center rounded-3">
                    <span className="primary-text fs-20">  <RiErrorWarningLine /></span>
                    <h5 className="primary-text ff-poppins-semiBold p-0 m-0 fs-15" >Oh no! Delivery persons unavailable!</h5>
                    <p className="primary-text ff-poppins-regular p-0 m-0 fs-12">Please select a different delivery option</p>
                  </div>


                  <div>
                    <div className="mt-3">
                      <h5 className="ff-poppins-semiBold fs-16 text-dark ">Choose Delivery Options</h5>
                      <p className=" ff-poppins-regular  fs-12 secondary-text-2 ">Choose timeslot when order will be delivered</p>
                    </div>

                    <div className=" " style={{ scroll: "hide" }}>

                      <div>
                        <div className={`${deliverytype == "instant" ? "primary-box primary-text" : "secondary-box"}  relative-box rounded-3 mt-2 mb-2`} onClick={() => setDeliverytype("instant")} >
                          <div className="d-flex justify-content-between align-items-center p-3"  >
                            <div className="d-flex align-items-center">
                              {
                                deliverytype == "instant" ?
                                  <img src={select_circle} height="25px" width="25px" /> :
                                  <img src={unselect_circle} height="25px" width="25px" />
                              }
                              <div className="ms-2 ">
                                <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold"> Re-assign Instant Delivery</h6>
                                <p className="fs-10 p-0 m-0 ff-poppins-regular ">You can attempt to reassign the instant delivery.</p>
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>

                      <div className={`${deliverytype == "slot" ? "primary-box primary-text" : "secondary-box"}  relative-box rounded-3 mt-2`} onClick={() => setDeliverytype("slot")}>
                        <div className="d-flex justify-content-between align-items-center p-3" >
                          <div className="d-flex align-items-center">
                            {
                              deliverytype == "slot" ?
                                <img src={select_circle} height="25px" width="25px" /> :
                                <img src={unselect_circle} height="25px" width="25px" />
                            }
                            <div className="ms-3">
                              <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Change to Slot Delivery</h6>
                              <p className="fs-10 p-0 m-0 ff-poppins-regular ">Hassle free slot delivery</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3 text-center">
                        <div className={` ${!deliverytype ? "opacity_5" : ""} primary-bg fs-12 ff-poppins-regular rounded-2 text-light p-2`} onClick={() => deliverytype ? handleContinue() : ""}>
                          Continue
                        </div>
                        <p className="fs-14 text-dark ff-poppins-semiBold mt-2 mb-2 ">OR</p>
                        <div className="primary-border fs-12 ff-poppins-semiBold rounded-2  primary-text p-2 " onClick={() => opencancelOrderModal()}>
                          Cancel my order <span className="ms-2"> <IoIosArrowForward /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {cancelConfirmModal && <div className="modal-backdrop fade show"></div>}
            </div>
          </div>
        }

        <div className={`modal fade`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={cancelConfirmModalRef} style={{ backgroundColor: "#fff" }} >
          <div className="modal-dialog modal-dialog-centered">
            <div class="modal-content modal-success px-4 py-2" style={{ width: "70%" }}>
              <div class="modal-body d-flex justify-content-center ff-poppins-semiBold">
                Order Cancelled
              </div>

              <img src={AppointmentCancelled} alt="My Image" />

              <div class="mb-4 d-flex text-center justify-content-center ff-poppins-regular">
                The order has been cancelled successfully.
              </div>
              <button class="text-center text-white rescheduleCancelBtnPP ff-poppins-semiBold" onClick={handleOkClick}   >
                OK{" "}
              </button>
            </div>
          </div>
        </div>

        <div className="modal fade" tabIndex="-1" aria-hidden="true" ref={cancelBalanceRequestModalRef} style={{ backgroundColor: "rgba(76 72 72 / 50%)" }}  >
          <div className="modal-dialog modal-dialog-centered"  >
            <div className="modal-content p-4" style={{ width: "75%" }}>
              <div className="text-center mb-3">
                <h1 className="ff-poppins-semiBold fs-14 mb-3" id="staticBackdropLabel">
                  Cancel Request
                </h1>
                <p className="fs-13 ff-poppins-regular">
                  Are you sure want to cancel the payment request?
                </p>
              </div>

              <div className="d-flex justify-content-between">

                <button className="ouline-none fs-14 col-4 border border-0 ff-poppins-regular primary-bg rounded-pill text-white" onClick={() => cancelBalanceRequest()} >
                  {
                    isLoading ?
                      <div className="d-flex justify-content-center">
                        <div class="spinner-border mt-1 text-light" role="status" style={{ height: "20px", width: "20px" }} >
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                      :
                      "Confirm"
                  }
                </button>
                <button className="ouline-none fs-14 col-4 border border-0 ff-poppins-regular secondary-bg-1   rounded-pill" onClick={closeCancelBalanceRequestModal} > Cancel    </button>
              </div>
            </div>
          </div>
        </div>

        <div className={`modal fade`} id="successMoadl" tabIndex="-1" ref={paymentSuccessModalRef} style={{ backgroundColor: "#d1d1d1" }}   >
          <div className="modal-dialog modal-dialog-centered mainModal">
            <div className="modal-content rounded-4" style={{ width: "70%" }}>

              <div className="d-flex justify-content-center align-items-center" style={{ height: "270px", width: "100%" }} >

                <Lottie animationData={SuccessLotie} loop={false} autoPlay={true} style={{ width: "250px", height: "250px" }} />

              </div>

              <div className="ff-poppins-medium fs-14 text-center">
                <div className="text-center fw-bold primary-text">
                  Payment Successful.
                </div>
                <div className="text-center ff-poppins-medium mt-2">
                  Redirecting you to your ticket.
                </div>
                <button type="button" className="paymentSuccessOkBtn"
                  onClick={handleSuccessOkClick}  >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="offcanvas" tabindex="-1" style={{ borderTopLeftRadius: 15, borderTopRightRadius: 15, width: 390 }} ref={canceldisputeModalRef}  >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title ff-poppins-semiBold text-dark fs-16" id="offcanvasBottomLabel">Reason for Dispute</h5>
            <button type="button" class="btn-close" onClick={closeDisputeModal}></button>
          </div>
          <div class="offcanvas-body small">
            <textarea
              className="w-100 rounded-2 fs-12 ouline-none ff-poppins-regular custom-input p-2 mb-2"
              style={{ height: "100px" }}
              placeholder="Enter the reason for your dispute"
              value={dispute}
              maxLength={120}
              onChange={(e) => {
                let cleanedValue = e.target.value
                  .replace(/[^a-zA-Z0-9\s!@%?><()*&_+=$\/\]\-]/g, '')
                  .replace(/\s+/g, ' ')
                  .trimStart();
                if (cleanedValue.length <= 120) {
                  setDispute(cleanedValue);
                }
              }}
            ></textarea>

            <div className='d-flex justify-content-end ff-poppins-regular mb-2 fs-14'>{dispute?.length ? dispute?.length : 0} / 120</div>

            <button className="w-100 primary-bg border-0 text-white ff-poppins-medium py-2 rounded"
              onClick={() => {
                if (!dispute) {
                  showToast("Please enter your dispute reason.");

                }
                else {
                  const cleaned = dispute.trim().replace(/\s+/g, ' ');
                  if (cleaned.length < 3 || !/[A-Za-z]/.test(cleaned)) {
                    showToast("Please enter atleast more then 3 charater ");
                    return;
                  }
                  setDispute(cleaned);
                  raisedispute();
                }
              }}
            >
              Raise Dispute
            </button>


          </div>
          {/* <div class="offcanvas-header">
            <h5 class="offcanvas-title ff-poppins-semiBold fs-16" id="offcanvasBottomLabel">Dispute reason</h5>
            <button type="button" class="btn-close" onClick={closeDisputeModal}></button>
          </div>
          <div class="offcanvas-body small">
            <textarea className="w-100 rounded-2 p-2 mb-3" placeholder="please provide details of your dispute reason."
              value={dispute}
              onChange={(e) => setDispute(e.target.value)}>
            </textarea>
            <button className="w-100 primary-bg border-0 text-white ff-poppins-semiBold py-2 rounded" onClick={() => raisedispute()}>Raise Dispute</button>
          </div> */}
        </div>
      </div>

      <div className="offcanvas offcanvas-bottomm  offcanvass main" style={{ height: 140 }} tabIndex="-1" ref={payBalancerequestModal}  >
        <div className="d-flex justify-content-center">
          <div class="modal-content p-2  bg-white">
            <div class="">
              <h1 class="d-flex ff-poppins-semiBold justify-content-center fs-16 mb-3" id="staticBackdropLabel" >
                Pay Balance
              </h1>
            </div>
            <div class="">
              <p className="fs-13 ff-poppins-medium text-center">
                <span> {vendor?.vendor_company_name}</span> has requested you to pay the balance
                amount <span className="primary-text">  (Rs.{payment?.balance_amount})</span>
              </p>
            </div>
            <div class="d-flex justify-content-center gap-3">
              <button class="ff-poppins-regular fs-13 PayBtn px-5 py-1 rounded-pill" onClick={() => payBalance()}> Pay </button>
              <button class="ff-poppins-regular fs-13 rejectBtn px-5 py-1 rounded-pill" onClick={() => openCancelBalanceRequestModal()} >
                Reject
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="offcanvas addOnModel_scroll p-2" style={{ maxHeight: "100%", borderTopLeftRadius: 15, borderTopRightRadius: 15, width: 390 }} tabindex="-1" aria-labelledby="offcanvasBottomLabel" ref={editOrderModalRef} >
        <div className="mb-2">
          <p className="m-0 mb-3 fs-12 ff-poppins-regular mt-2">{vendor?.vendor_company_name} has requested you to edit the order products</p>

          <div className="mt-2">
            <div className="position-relative ">
              <div className="position-absolute top-0 start-50 translate-middle bg-white fs-14 ff-poppins-semiBold">Order Products</div>
              <div className="edit_Order_Box   mt-2">
                {
                  (() => {
                    let requestedProducts = editOrder?.requested_products ? JSON.parse(editOrder?.requested_products) : [];
                    return orderdetail?.map((proId, index) => {
                      requestedProducts.includes(proId?.product_id)
                      return (
                        <div>
                          <div className="d-flex justify-content-between ff-poppins-regular fs-13 mt-1 mb-1" key={index}  >
                            <div className="m-0 ff-poppins-regular fs-12">  {proId?.product_name} </div>
                            <div className="d-flex ">
                              {
                                proId?.added_addons_details?.length > 0 ?
                                  <div onClick={() => toggleAddon(index)} style={{ cursor: 'pointer' }}>
                                    {showAddonsState[index] ? (
                                      <SlArrowUp className="me-2" />
                                    ) : (
                                      <SlArrowDown className="me-2" />
                                    )}
                                  </div>
                                  : ""
                              }
                              <p className="m-0 fs-12 ms-2">
                                {proId?.added_count} x {Number(proId?.price) + Number(proId?.addons_cost)}
                              </p>
                            </div>
                          </div>
                          {
                            proId?.added_addons_details?.length > 0 ?
                              <div className="m-0 fs-10 col-10 ff-poppins-regular">
                                {showAddonsState[index] ? (
                                  proId?.added_addons_details?.map((addon, addonIndex) => (
                                    <div className="mt-1 d-flex justify-content-between">
                                      <div>  {addon?.addon_name} - {addon?.name}  </div>
                                      <div>  {proId?.added_count} x {addon?.price}  </div>
                                    </div>
                                  ))
                                ) : <span className="fs-10"> ({proId?.added_addons_details?.map((addon) => addon.name.trim()).join(', ')})</span>}
                              </div> : ""
                          }

                        </div>
                      );
                    });
                  })()
                }
              </div>
            </div>
            <div className="position-relative mt-4">
              <div className="position-absolute top-0 start-50 translate-middle bg-white fs-14 ff-poppins-semiBold">
                Changed Products
              </div>
              <div className="edit_Order_Box mt-2">
                {orderdetail?.length > 0 &&
                  orderdetail?.map((data, index) => {
                    let requestedProducts = editOrder?.requested_products ? JSON.parse(editOrder?.requested_products) : [];
                    const checkedIndex = requestedProducts?.findIndex((p) => p.productId === data?.product_id);

                    if (checkedIndex > -1) {
                      const selectedProduct = requestedProducts[checkedIndex];

                      return (
                        <div className="mt-1 mb-1" key={index}>
                          <div className="ff-poppins-regular fs-12">
                            <div className="m-0 primary-text fs-12">{data?.product_name}</div>
                            <span className="fs-10">
                              {data?.added_addons_details
                                ? data?.added_addons_details?.map((addon) => addon?.name?.trim()).join(", ")
                                : ""}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between fs-11 ff-poppins-regular mt-2">
                            <div>
                              <p className="m-0">Order Product: {data?.added_count}</p>
                              <p className="m-0">
                                Available Now: {data?.added_count - selectedProduct?.unAvailableCount}
                              </p>
                            </div>
                            <div>
                              <div className="mt-3">
                                {selectedProduct?.availableType === 4 ? (
                                  <span className="primary-text">Permanently Unavailable</span>
                                ) : (
                                  <>
                                    {"Next Available From: "}
                                    {selectedProduct?.availableType === 1 ? (
                                      <span className="primary-text">
                                        {hoursFromNow(selectedProduct?.availableTime)}
                                      </span>
                                    ) : selectedProduct?.availableType === 2 ? (
                                      <span className="primary-text">Tomorrow</span>
                                    ) : selectedProduct?.availableType === 3 ? (
                                      <span className="primary-text">
                                        {selectedProduct?.availableDate
                                          ? new Date(selectedProduct?.availableDate).toLocaleDateString(
                                            "en-GB",
                                            dateOption
                                          )
                                          : new Date().toLocaleDateString("en-GB", dateOption)}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          {index < orderdetail.length - 1 && (
                            <div className="border_bottom-Dashed mb-2"></div>
                          )}
                        </div>
                      );
                    }
                    return null;
                  })}
              </div>

            </div>
          </div>

          <div className="ff-poppins-regular fs-12 mt-2" style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
            <p className="m-0 ff-poppins-semiBold">Reason :</p>
            <p className="ms-2 mb-2 ff-poppins-regular">{editOrder?.request_reason}</p>
            <div className="d-flex justify-content-between">
              <button className="bg-success text-light ff-poppins-regular p-1 fs-12 border-0 rounded-4 col-5 ms-4" onClick={() => acceptEditorderRequest()} >Accept or Edit Order</button>
              <button className="bg-danger text-light ff-poppins-regular p-1 fs-12 border-0  rounded-4 col-5 me-4" onClick={() => cancelEditorderRequest()}>Reject & Cancel Order</button>
            </div>
          </div>



        </div>
      </div>

      <div class="modal fade" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1" ref={cancelOrderConfirmModalRef}    >
        <div class="modal-dialog modal-dialog-centered mainModal p-4">
          <div class="modal-content p-3 text-center w-75">
            <div class="">
              <h1 class="d-flex ff-poppins-semiBold justify-content-center fs-14 mb-3" id="staticBackdropLabel"   >
                Cancel Order
              </h1>
            </div>
            <div class="">
              <p className="m-0 fs-10 ff-poppins-regular text-center mb-3">
                Are you sure want to cancel the order 100% refund ?
              </p>
            </div>
            {
              isLoading ?
                <div className="d-flex justify-content-center">
                  <div class="spinner-border mt-1 primary-text" role="status" style={{ height: "25px", width: "25px" }} >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                :
                <div className="d-flex justify-content-around">
                  <button class="btn primary-bg rounded-pill fs-12 col-4 ff-poppins-regular text-white" onClick={() => cancel_order(2)} >
                    Confirm
                  </button>
                  <button class="btn secondary-bg-1 text-dark fs-12 col-4 ff-poppins-regular rounded-pill" onClick={() => closecancelOrderModal()} >
                    Cancel
                  </button>
                </div>
            }

          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-bottomm Chooseaddres rounded-2 main"
        tabIndex="-1" aria-labelledby="offcanvasBottomLabel"
        ref={instructionsNoteRef} style={{ height: 'auto', maxHeight: '47vh', zIndex: 1045 }}>
        <div className="offcanvas-body small bg-light position-relative ">

          <div className="d-flex justify-content-between">
            <h5 className="ff-poppins-semiBold fs-16 text-dark ">Instructions Note</h5>
            {
              !pauseicon &&
              <div onClick={() => closeinstructionsModal()}>
                <IoMdClose />
              </div>
            }
          </div>
          <div>
            <div className={`w-100 ${!restartRecord ? "primary-border-1" : "secondary-border"} rounded-2 p-1`} style={{ height: "55px" }}    >
              {restartRecord ? (
                <div className="d-flex align-items-center justify-content-between p-1">
                  <p className={`fs-12 m-0 ff-poppins-medium ${pauseicon ? "text-danger" : ""}`}   >
                    {pauseicon ? `Recording... ${formatTime(recordingTime)}`
                      : "Click to record instructions"}
                  </p>
                  <div className="d-flex justify-content-center align-items-center" style={{ width: 36, height: 36 }}
                    onClick={() => (pauseicon ? stopVoiceRecording() : startVoiceRecording())}
                  >
                    {!pauseicon ? (
                      <FaMicrophone className="fs-18 primary-text cursor-pointer" />
                    ) : (
                      <FaPause className="fs-18 primary-text" />
                    )}
                  </div>
                </div>

              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="d-flex align-items-center justify-content-between gap-4">

                    {/* Left: Play + Text */}
                    <div className="d-flex align-items-center gap-2">
                      <div
                        onClick={togglePlayAudio}
                        className="fs-15 primary-text cursor-pointer"
                      >
                        {isPlaying ? <FaStop /> : <FaPlay />}
                      </div>

                      <div className="fs-14 primary-text ff-poppins-medium">
                        Instructions Recorded
                      </div>
                    </div>

                    {/* Right: Time + Delete */}
                    <div className="d-flex align-items-center gap-2">
                      <div className="fs-14 ff-poppins-medium primary-text">
                        {formatTime(playTime)} / {recordingTime === 0 ? "0.00" : formatTime(recordingTime)}
                      </div>

                      <div
                        className="fs-18 text-danger cursor-pointer"
                        onClick={() => {
                          setRecordedAudioUrl(null);
                          deleteRecordedAudio();
                          setRestartRecord(true);
                          setPlayTime(0);
                        }}
                      >
                        <MdDeleteOutline />
                      </div>
                    </div>
                  </div>
                </div>

              )}
            </div>

          </div>
          <div>
            <h6 className="fs-14 mt-3 ff-poppins-semiBold ">Additional Note</h6>
            <textarea className="textAreaRP text-dark ff-poppins-regular fs-13 mb-1"
              placeholder="Type your instructions here..." value={consulation} maxLength={120}
              onChange={(e) => {
                let value = e.target.value;
                value = value.replace(/[^a-zA-Z0-9\s.,]/g, "");
                value = value.replace(/\s{2,}/g, " ");
                setConsulation(value);
              }}
            ></textarea>

          </div>
          <div className='d-flex justify-content-end ff-poppins-regular fs-14 mt-1 mb-3'>{consulation?.length} / 120</div>

          <button disabled={pauseicon == true} className="InstructionsNoteSaveBtn"
            onClick={() =>
              handleSendInstructions()
            }>
            {instructionisLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span className="visually-hidden">Loading...</span>
              </>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>

      {
        product?.payment_details?.courier_charge_request ?
          <div className="offcanvas offcanvas-bottomm modal-top-radies main" tabIndex="-1" aria-labelledby="offcanvasBottomLabel" ref={courierpaymentRequestRef} style={{ maxHeight: '40vh', zIndex: 1045, }}     >
            <div className="offcanvas-body small bg-light position-relative">
              <div className="p-1">
                <div>
                  <div className="primary-gradient-box p-2 text-center rounded-3">
                    <h5 className="primary-text ff-poppins-semiBold p-0 m-0 fs-15 mt-2">Extra charge for courier weight !</h5>
                    <p className=" p-1 ff-poppins-regular p-0 m-0 fs-12 mt-2">
                      Your order has additional weight after packing. An extra courier charge of
                      {" "}   <FaIndianRupeeSign className="fs-10" /> {product?.payment_details?.courier_charge_request?.amount_to_pay} {" "}
                      is required to proceed. Please confirm your choice below</p>
                  </div>

                  <div className="text-center">
                    <div className="border border-dark  rounded-3 p-2 text-center ff-poppins-regular fs-12 mb-1" onClick={() => opencancelcourierpaymentRequestModal()} >
                      Cancel order
                    </div>
                    <span className="ff-poppins-semiBold fs-14">OR</span>
                    <div className="primary-bg text-light rounded-3 mt-1 p-2 text-center ff-poppins-medium fs-12" onClick={() => payBalance()}>
                      Pay  <FaIndianRupeeSign className="me-1" /> {product?.payment_details?.courier_charge_request?.amount_to_pay}  & confirm
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div> : <></>
      }

      <div className="modal fade" tabIndex="-1" aria-hidden="true" ref={cancelcourierpaymentRequestRef} style={{ backgroundColor: "rgba(76 72 72 / 50%)" }}  >
        <div className="modal-dialog modal-dialog-centered"  >
          <div className="modal-content p-4" style={{ width: "75%" }}>
            <div className="text-center mb-3">
              <h1 className="ff-poppins-semiBold fs-14 mb-3" id="staticBackdropLabel">
                Cancel order
              </h1>
              <p className="fs-13 ff-poppins-regular">
                Are you sure want to cancel the payment request and cancel order ?
              </p>
            </div>

            <div className="d-flex justify-content-between">
              <button className="ouline-none fs-14 col-4 border border-0 ff-poppins-regular secondary-bg-1   rounded-pill" onClick={closecancelcourierpaymentRequestModal} > Cancel </button>

              <button className="ouline-none fs-14 col-4 border border-0 ff-poppins-regular primary-bg rounded-pill text-white" onClick={() => cancelCorierPaymentRequest()} >
                {
                  isLoading ?
                    <div className="d-flex justify-content-center">
                      <div class="spinner-border mt-1 text-light" role="status" style={{ height: "20px", width: "20px" }} >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                    :
                    "Confirm"
                }
              </button>
            </div>
          </div>
        </div>
      </div>


      {changeDeliveryrequestModal &&
        <>
          <div className="modalBackdrop change-backdrop" ></div>
          {/* <div className={` offcanvas-bottom-modal ${changeDeliveryrequestModal ? 'show' : ''}`} >
            <div className="text-center ">
              <h6 class=" ff-poppins-semiBold mb-3 fs-14"> Change Delivery Request</h6>
              <p className="fs-12 ff-poppins-regular secondary-text-1  text-center">
                Change delivery type request sent to the merchant. Please wait while they accept or cancel the request using the button below.
              </p>
              <button class="ff-poppins-regular fs-13 rejectBtn px-5 py-1 mb-3 rounded-pill" onClick={() => cancelEditdeliveryTypeRequest()} >
                Cancel
              </button>
            </div>
          </div> */}
          <div className={`offcanvas-bottom-modal ${changeDeliveryrequestModal ? 'show' : ''}`}>
            <div className="status-modal-card p-2 rounded-4  bg-white">


              <div className="text-center">
                {/* Icon with soft background */}
                {/* <div className="icon-circle mb-3 mx-auto">
                  <i className="bi bi-shop-window text-primary fs-4"></i>
                </div> */}

                <h5 className="ff-poppins-bold mb-2 fs-18 color-dark">
                  Waiting for Merchant
                </h5>

                <p className="fs-13 ff-poppins-regular secondary-text px-2 mb-4">
                  We've notified the store about your request. You can stay on this screen or cancel if you've changed your mind.
                </p>

                {/* Primary Action: Outline style for "Cancel" to keep it low-priority */}
                <button disabled={isLoading}
                  className="btn-outline-danger-soft w-100 py-2 rounded-pill ff-poppins-medium transition-all"
                  onClick={() => cancelEditdeliveryTypeRequest()}
                >


                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span className="visually-hidden">Loading...</span>
                    </>
                  ) : (
                    ' Dismiss Request'
                  )}
                </button>
              </div>
            </div>
          </div>
        </>
      }
      {
        changeDeliveryTypeModal &&
        <ChangeDeliverytypeOffcanvas isOpen={changeDeliveryTypeModal} toggleDeliveryTypeOffCanvas={toggleDeliveryTypeOffCanvas} data={product} openPaymentSuccessModal={openPaymentSuccessModal} />
      }

      {iscourierrequestModalOpen || deliveryTypeModal && <div className="modal-backdrop fade show" ></div>}
      {isCancelModalOpen && <div className="modal-backdrop fade show" ></div>}
      {disputeModalOpen && <div className="modal-backdrop fade show" ></div>}


      {isModalOpen || isinstructionModalOpen && <div className="modal-backdrop fade show" ></div>}
    </div >
  );
};

export default ProductPass;





